/* eslint-disable */

import {
  isAndroid,
  isDesktop,
  isIPad13,
  isIPhone13,
  isTablet,
} from "react-device-detect";
import {
  iconAdrenalina,
  iconAvisaEquipo,
  iconCausaParada,
  iconCompresiones,
  iconDesfibrilacion,
  iconMonitor,
  iconNoResponde,
  iconNotas,
  iconRitmoEcg,
  iconTecnicas,
  iconVentilaciones,
  iconReanimacion,
} from "./ImagesCache";
import { text } from "@fortawesome/fontawesome-svg-core";

//lista de constantes
export const BASEURLAPI = "https://simularcp.ninjastudio.dev/api/v1";
export const PRIMARY_COLOR = "#2aac9c";
export const SECONDARY_COLOR = "#eaf7f5";
export const THIRD_COLOR = "#f9fafb";
export const DEVMODE = true;

export const OptionsEvaluaRitmo = [
  "Asistolia",
  "AESP",
  "Fibrilación ventricular",
  "Taquicardia ventricular sin pulso",
  "Otro",
];
export const OptionsRitmoECG = [
  "Asistolia",
  "Actividad eléctrica sin pulso",
  "Fibrilación ventricular",
  "Taquicardia ventricular sin pulso",
  "Bloqueo de 1er grado",
  "Taquicardia ventricular con pulso",
  "Bloqueo de 2º Mobitz I",
  "Torsaide de Pointes",
  "Bloqueo de 2º Mobitz II",
  "Taquicardia supraventricular",
  "Bloque de 3er grado",
  "Ritmo sinusal",
];

export const OptionsRitmoECG_EN = [
  "Asystole",
  "Pulseless electrical activity",
  "Ventricular fibrillation",
  "Pulseless ventricular tachycardia",
  "1st degree block",
  "Ventricular tachycardia with a pulse",
  "2nd degree block Mobitz I",
  "Torsaide de Pointes",
  "2nd degree block Mobitz II",
  "Supraventricular tachycardia",
  "3rd degree block",
  "Sinus rhythm",
];

export const OptionsRitmoECGCritical = [
  "Asistolia",
  "Actividad eléctrica sin pulso",
  "Fibrilación ventricular",
  "Taquicardia ventricular sin pulso",
];

export const OptionsRitmoECGCritical_EN = [
  "Asystole",
  "Pulseless electrical activity",
  "Ventricular fibrillation",
  "Pulseless ventricular tachycardia",
];

export const OptionsRitmoECGNormal = [
  "Taquicardia ventricular con pulso",
  "Torsaide de pointes",
  "Bloqueo de 1er grado",
  "Bloqueo de 2º Mobitz I",
  "Bloqueo de 2º Mobitz II",
  "Bloque de 3er grado",
  "Taquicardia supraventricular",
  "Ritmo sinusal",
  "Otro",
];

export const OptionsRitmoECGNormal_EN = [
  "Ventricular tachycardia with a pulse",
  "Torsaide de pointes",
  "1st degree block",
  "2nd degree block Mobitz I",
  "2nd degree block Mobitz II",
  "3rd degree block",
  "Supraventricular tachycardia",
  "Sinus rhythm",
  "Other",
];

const CausaParadaH = [
  "Hipoxia",
  "Hipovolemia",
  "Hipo/hiperpotasemia/metabólicas",
  "Hipo/Hipertermia",
];

const CausaParadaT = [
  "Trombosis coronaria/pulmonar",
  "Neumotórax a tensión",
  "Taponamiento cardiaco",
  "Tóxicos",
];

const Tecnicas = [
  "Cánula de guedel",
  "Aspiración de secreciones",
  "Transfusión de hemoderivados",
  "Calentamiento paciente",
  "Enfriamiento paciente",
  "Drenaje pleural",
  "Trombolisis",
  "Angiografía coronaria",
  "Pericardiocentesis",
  "Antídoto",
  "Canaliación vía central",
  "Cardioversión",
  "Marcapasos externo",
  "ECG",
];

const Farmacos = [
  "Adenosina",
  "Bicarbonato sódico",
  "Cloruro de Calcio",
  "Diazepam",
  "Flumazenilo",
  "Lidocaína",
  "Sulfato de magnesio",
  "Naloxona",
  "Nitroglicerina",
  "Potasio",
  "Gluconato de calcio",
  "Insulina rapida",
  "Atropina",
];

export const OptionsCausaParada = [CausaParadaH, CausaParadaT];

export const OptionsTecnicasFarmacos = [Tecnicas, Farmacos];

export const RcpQuality = [
  {
    title: "Profundidad",
    description: "",
    object: "profundidad",
    selectedOption: null,
    options: [
      {
        isSelected: false,
        title: "Déficit",
        desc: "No realiza",
        color: "#FEEFF2",
        colorCheck: "#F9839A",
      },
      {
        isSelected: false,
        title: "Adecuado",
        desc: "Realiza parcial",
        color: "#FDF7DB",
        colorCheck: "#F4D947",
      },
      {
        isSelected: false,
        title: "Excelente",
        desc: "Realiza completo",
        color: "#EAF7F5",
        colorCheck: "#2AAC9C",
      },
    ],
  },
  {
    title: "Frecuencia",
    description: "",
    object: "frecuencia",
    selectedOption: null,
    options: [
      {
        isSelected: false,
        title: "Déficit",
        desc: "No realiza",
        color: "#FEEFF2",
        colorCheck: "#F9839A",
      },
      {
        isSelected: false,
        title: "Adecuado",
        desc: "Realiza parcial",
        color: "#FDF7DB",
        colorCheck: "#F4D947",
      },
      {
        isSelected: false,
        title: "Excelente",
        desc: "Realiza completo",
        color: "#EAF7F5",
        colorCheck: "#2AAC9C",
      },
    ],
  },
  {
    title: "Liberación\ntorácica",
    description: "",
    object: "liberacion",
    selectedOption: null,
    options: [
      {
        isSelected: false,
        title: "Déficit",
        desc: "No realiza",
        color: "#FEEFF2",
        colorCheck: "#F9839A",
      },
      {
        isSelected: false,
        title: "Adecuado",
        desc: "Realiza parcial",
        color: "#FDF7DB",
        colorCheck: "#F4D947",
      },
      {
        isSelected: false,
        title: "Excelente",
        desc: "Realiza completo",
        color: "#EAF7F5",
        colorCheck: "#2AAC9C",
      },
    ],
  },
  {
    title: "Posición",
    description: "",
    object: "posicion",
    selectedOption: null,
    options: [
      {
        isSelected: false,
        title: "Déficit",
        desc: "No realiza",
        color: "#FEEFF2",
        colorCheck: "#F9839A",
      },
      {
        isSelected: false,
        title: "Adecuado",
        desc: "Realiza parcial",
        color: "#FDF7DB",
        colorCheck: "#F4D947",
      },
      {
        isSelected: false,
        title: "Excelente",
        desc: "Realiza completo",
        color: "#EAF7F5",
        colorCheck: "#2AAC9C",
      },
    ],
  },
  {
    title: "30:2",
    description: "",
    object: "302",
    selectedOption: null,
    options: [
      {
        isSelected: false,
        title: "Déficit",
        desc: "No realiza",
        color: "#FEEFF2",
        colorCheck: "#F9839A",
      },
      {
        isSelected: false,
        title: "Adecuado",
        desc: "Realiza parcial",
        color: "#FDF7DB",
        colorCheck: "#F4D947",
      },
      {
        isSelected: false,
        title: "Excelente",
        desc: "Realiza completo",
        color: "#EAF7F5",
        colorCheck: "#2AAC9C",
      },
    ],
  },
];

export const NonTechnical = [
  {
    title: "NoTecnicas[T2]",
    object: "papeles",
    description: "NoTecnicas[P2]",
    selectedOption: null,
    options: [
      {
        isSelected: false,
        title: "Déficit",
        desc: "No realiza",
        color: "#FEEFF2",
        colorCheck: "#F9839A",
      },
      {
        isSelected: false,
        title: "Adecuado",
        desc: "Realiza parcial",
        color: "#FDF7DB",
        colorCheck: "#F4D947",
      },
      {
        isSelected: false,
        title: "Excelente",
        desc: "Realiza completo",
        color: "#EAF7F5",
        colorCheck: "#2AAC9C",
      },
    ],
  },
  {
    title: "NoTecnicas[T3]",
    object: "comunicacion",
    description: "NoTecnicas[P3]",
    selectedOption: null,
    options: [
      {
        isSelected: false,
        title: "Déficit",
        desc: "No realiza",
        color: "#FEEFF2",
        colorCheck: "#F9839A",
      },
      {
        isSelected: false,
        title: "Adecuado",
        desc: "Realiza parcial",
        color: "#FDF7DB",
        colorCheck: "#F4D947",
      },
      {
        isSelected: false,
        title: "Excelente",
        desc: "Realiza completo",
        color: "#EAF7F5",
        colorCheck: "#2AAC9C",
      },
    ],
  },
  {
    title: "NoTecnicas[T4]",
    object: "ayuda",
    description: "NoTecnicas[P4]",
    selectedOption: null,
    options: [
      {
        isSelected: false,
        title: "Déficit",
        desc: "No realiza",
        color: "#FEEFF2",
        colorCheck: "#F9839A",
      },
      {
        isSelected: false,
        title: "Adecuado",
        desc: "Realiza parcial",
        color: "#FDF7DB",
        colorCheck: "#F4D947",
      },
      {
        isSelected: false,
        title: "Excelente",
        desc: "Realiza completo",
        color: "#EAF7F5",
        colorCheck: "#2AAC9C",
      },
    ],
  },
  {
    title: "NoTecnicas[T5]",
    object: "recursos",
    description: "NoTecnicas[P5]",
    selectedOption: null,
    options: [
      {
        isSelected: false,
        title: "Déficit",
        desc: "No realiza",
        color: "#FEEFF2",
        colorCheck: "#F9839A",
      },
      {
        isSelected: false,
        title: "Adecuado",
        desc: "Realiza parcial",
        color: "#FDF7DB",
        colorCheck: "#F4D947",
      },
      {
        isSelected: false,
        title: "Excelente",
        desc: "Realiza completo",
        color: "#EAF7F5",
        colorCheck: "#2AAC9C",
      },
    ],
  },
  {
    title: "NoTecnicas[T6]",
    object: "vision",
    description: "NoTecnicas[P6]",
    selectedOption: null,
    options: [
      {
        isSelected: false,
        title: "Déficit",
        desc: "No realiza",
        color: "#FEEFF2",
        colorCheck: "#F9839A",
      },
      {
        isSelected: false,
        title: "Adecuado",
        desc: "Realiza parcial",
        color: "#FDF7DB",
        colorCheck: "#F4D947",
      },
      {
        isSelected: false,
        title: "Excelente",
        desc: "Realiza completo",
        color: "#EAF7F5",
        colorCheck: "#2AAC9C",
      },
    ],
  },
];

export const ComponentOptions = {
  startCaseButton: {
    titleOn: "Parar caso",
    titleOff: "Iniciar caso",
  },
  startPcrButton: {
    titleOn: "RCE",
    titleOff: "Inicio PCR",
  },
  vascularAccessSwitch: {
    subtitleActive: "",
    subtitle: "",
    initialState: false,
  },
  iotSwitch: {
    subtitleActive: "",
    subtitle: "",
    initialState: false,
  },
  asyncSwitch: {
    subtitleActive: "",
    subtitle: "",
    initialState: false,
  },
  monitorButton: {
    titleStart: "Monitor",
    titleOff: "Evalua ritmo",
    titleOn: "Evalua ritmo",
    icon: iconMonitor,
    initialState: false,
    disableInitialTimer: true,
    type: "restart",
    onlyCounter: true,
  },
  compressionsButton: {
    titleStart: "Inicia compresiones",
    titleOff: "Inicia compresiones",
    titleOn: "Detiene compresiones",
    icon: iconCompresiones,
    initialState: true,
    onlyCounter: true,
  },
  ventsButton: {
    titleStart: "Inicia ventilaciones",
    titleOff: "Inicia ventilaciones",
    titleOn: "Detiene ventilaciones",
    icon: iconVentilaciones,
    initialState: false,
    onlyCounter: true,
  },
  rcpButton: {
    titleStart: "Inicia RCP",
    titleOff: "Inicia RCP",
    titleOn: "Detiene RCP",
    icon: iconReanimacion,
    initialState: false,
  },
  defibrillationButton: {
    titleStart: "Desfibrilacion",
    titleOff: "Desfibrilacion",
    titleOn: "Desfibrilacion",
    icon: iconDesfibrilacion,
    initialState: false,
    type: "restart",
    onlyCounter: true,
  },
  adrenalinButton: {
    titleStart: "Adrenalina",
    titleOff: "Adrenalina",
    titleOn: "Adrenalina",
    icon: iconAdrenalina,
    initialState: false,
    type: "restart",
    onlyCounter: true,
  },
  amiodaroneButton: {
    titleStart: "Amiodarona",
    titleOff: "Amiodarona",
    titleOn: "Amiodarona",
    icon: iconAdrenalina,
    initialState: false,
    type: "restart",
    onlyCounter: true,
  },
  causaButton: {
    title: "Detecta causa parada",
    icon: iconCausaParada,
    values: [
      { title: "H", status: false },
      { title: "T", status: false },
    ],
    initialState: true,
  },
  ritmoEcgButton: {
    title: "Ritmo ECG Paciente",
    icon: iconRitmoEcg,
    type: "oneSelection",
    values: [
      {
        status: false,
        title: "",
      },
    ],
    minimal: true,
    initialState: true,
  },
  tecnicasButton: {
    title: "Técnicas y Fármacos",
    icon: iconTecnicas,
    values: [],
    initialState: true,
  },
  notesButton: {
    title: "Notas",
    icon: iconNotas,
    values: [{ status: false }],
    minimal: true,
    initialState: true,
  },
};

export const TimelineDefault = {
  name: "simularcp-" + +new Date(),
  type: "basic",
  date: +new Date(),
  history: [],
  startCase: null,
  stopCase: null,
  PCR: [],
  RCE: [],
  isSafeScene: false,
  shoutedHelp: false,
  consistency: null,
  notRespond: null,
  openAirWay: [],
  checkVentilation: [],
  notifiesEmergencyTeam: null,
  lateralSafetyPosition: null,
  RCP: [],
  DEA: [],
  compressions: [],
  vents: [],
  defibrillation: [],
  adrenalin: [],
  amiodarone: [],
  naloxone: [],
  diazepam: [],
  vascularAccess: null,
  otDevice: null,
  monitor: [],
  complete: false,
  conscious: true,
  toser: null,
  backBlows: [],
  compressionsAbs: [],
  compressionsThorax: [],
  basicVitalSupport: null,
  Ritmo: [],
  ECG: "",
  ecgPaciente: "",
  CausaT: [],
  CausaH: [],
  Tecnicas: [],
  Farmacos: [],
  Notas: [],
  deficit: [],
  calidadRcp: [],
  nonTechnical: NonTechnical,
  rcpQuality: RcpQuality,
  asyncDevice: false,
};

export const PlatformMobile = isIPhone13 || isAndroid;
export const PlatformTablet = isIPad13 || isTablet;
export const PlatformDesktop = isDesktop;

export const DEFAULT_TRANSLATIONS = [
  {
    id: "Avanzado",
    ES: "Avanzado",
    EN: "Advanced",
    IT: "Avanzato",
    PT: "Avançado",
  },
  {
    id: "logIn",
    ES: "Iniciar sesión",
    EN: "Login",
    IT: "Accesso",
    PT: "Iniciar sessão",
  },
  {
    id: "userName",
    ES: "Nombre de usuario",
    EN: "User Name",
    IT: "Nome utente",
    PT: "Nome do utilizador",
  },
  {
    id: "password",
    ES: "Clave",
    EN: "Password",
    IT: "Password di accesso",
    PT: "Palavra-passe",
  },
  {
    id: "Registro",
    ES: "Registro",
    EN: "Register",
    IT: "Registro",
    PT: "Registar",
  },
  {
    id: "compresionesVentilaciones",
    ES: "¿Desea medir compresiones y ventilaciones?",
    EN: "Would you like to measure compressions and ventilations?",
    IT: "Volete misurare le compressioni e le ventilazioni?",
    PT: "Pretende medir as compressões e as ventilações?",
  },
  {
    id: "async",
    ES: "Asíncrono",
    EN: "Asynchronous",
    IT: "Asincrono",
    PT: "Assíncrono",
  },
  {
    id: "Iniciar caso",
    ES: "Iniciar caso",
    EN: "Start case",
    IT: "Inizio caso",
    PT: "Começar caso",
  },
  {
    id: "Parar caso",
    ES: "Parar caso",
    EN: "Stop case",
    IT: "Fermare caso",
    PT: "Parar caso",
  },
  {
    id: "Iniciar PCR",
    ES: "Iniciar PCR",
    EN: "Start PCR",
    IT: "Inizio PCR",
    PT: "Iniciar PCR",
  },
  { id: "RCE", ES: "RCE", EN: "ROSC", IT: "ROSC", PT: "RCE" },
  {
    ES: "Acceso vascular",
    EN: "Vascular Access",
    IT: "Accesso vascolare",
    PT: "Acesso vascular",
    id: "Acceso vascular",
  },
  { ES: "Acceso Vascular", EN: "AV", IT: "AV", PT: "AV", id: "AV" },
  {
    id: "IOT/DSG",
    ES: "IOT/DSG",
    EN: "ETI/LMA",
    IT: "IE/dispositivo sovraglottideo",
    PT: "EOT/Dispositivo supraglótico",
  },
  {
    id: "No responde/ no respira",
    ES: "No responde/no respira",
    EN: "Unresponsive/not breathing",
    IT: "Non risponde/ respirazione assente",
    PT: "Sem reação/não respira",
  },
  {
    id: "Avisa equipo reanimación",
    ES: "Avisa equipo reanimación",
    EN: "Call resuscitation team",
    IT: "Chiama team di rianimazione",
    PT: "Alertar equipa de reanimação",
  },
  {
    id: "Monitor",
    ES: "Monitor",
    EN: "Monitor",
    IT: "Monitoraggio",
    PT: "Monitorizar",
  },
  {
    id: "evaluaRitmo",
    ES: "Evalúa ritmo",
    EN: "Assess rhythm",
    IT: "Valuta ritmo",
    PT: "Analisar ritmo",
  },
  {
    id: "Inicia compresiones",
    ES: "Inicia compresiones",
    EN: "Starts chest compressions",
    IT: "Inizia le compressioni",
    PT: "Iniciar compressões",
  },
  {
    id: "Detiene compresiones",
    ES: "Detiene compresiones",
    EN: "Stops chest compressions",
    IT: "Interrompe le compressioni",
    PT: "Pára as compressões",
  },
  {
    id: "Inicia ventilaciones",
    ES: "Inicia ventilaciones",
    EN: "Starts ventilations",
    IT: "Inizia la ventilazione",
    PT: "Inicia a ventilação",
  },
  {
    id: "Detiene ventilaciones",
    ES: "Detiene ventilaciones",
    EN: "Stops ventilations",
    IT: "Interrompe le ventilazioni",
    PT: "Pára as ventilações",
  },
  {
    id: "Inicia RCP",
    ES: "Inicia RCP",
    EN: "Starts CPR",
    IT: "Inizia RCP",
    PT: "Inicia RCP",
  },
  {
    id: "Detiene RCP",
    ES: "Detiene RCP",
    EN: "Stops CPR",
    IT: "Interrompe RCP",
    PT: "Parar RCP",
  },
  {
    id: "Inicia monitor",
    ES: "Inicia monitor",
    EN: "Start monitor",
    IT: "Inizia monitor",
    PT: "Inicia monitor",
  },
  {
    id: "Detiene monitor",
    ES: "Detiene monitor",
    EN: "Stop monitor",
    IT: "Ferma monitor",
    PT: "Para monitor",
  },
  {
    id: "Desfibrilación",
    ES: "Desfibrilación",
    EN: "Shock",
    IT: "Shock",
    PT: "Desfibrilhação",
  },
  {
    id: "Inicia desfibrilación",
    ES: "Inicia desfibrilación",
    EN: "Start defibrillation",
    IT: "Inizia defibrillazione",
    PT: "Inicia desfibrilação",
  },
  {
    id: "Detiene desfibrilación",
    ES: "Detiene desfibrilación",
    EN: "Stop defibrillation",
    IT: "Ferma defibrillazione",
    PT: "Para desfibrilação",
  },
  {
    id: "Adrenalina",
    ES: "Adrenalina",
    EN: "Adrenaline",
    IT: "Adrenalina",
    PT: "Adrenalina",
  },
  {
    id: "Inicia adrenalina",
    ES: "Inicia adrenalina",
    EN: "Start adrenaline",
    IT: "Inizia adrenalina",
    PT: "Inicia adrenalina",
  },
  {
    id: "Detiene adrenalina",
    ES: "Detiene adrenalina",
    EN: "Stop adrenaline",
    IT: "Ferma adrenalina",
    PT: "Para adrenalina",
  },
  {
    id: "Amiodarona",
    ES: "Amiodarona",
    EN: "Amiodarone",
    IT: "Amiodarone",
    PT: "Amiodarona",
  },
  {
    id: "Inicia amiodarona",
    ES: "Inicia amiodarona",
    EN: "Start amiodarone",
    IT: "Inizia amiodarone",
    PT: "Inicia amiodarona",
  },
  {
    id: "Detiene amiodarona",
    ES: "Detiene amiodarona",
    EN: "Stop amiodarone",
    IT: "Ferma amiodarone",
    PT: "Para amiodarona",
  },
  {
    id: "detectaCausasReversibles",
    ES: "Detecta causas reversibles",
    EN: "Identify reversible causes",
    IT: "Identifica causa reversibili",
    PT: "Detectar causas reversíveis",
  },
  { id: "Hipoxia", ES: "Hipoxia", EN: "Hypoxia", IT: "Ipossia", PT: "Hipoxia" },
  {
    id: "Hipovolemia",
    ES: "Hipovolemia",
    EN: "Hypovolaemia",
    IT: "Ipovolemia",
    PT: "Hipovolémia",
  },
  {
    id: "Hipo/hiperpotasemia/metabólicas",
    ES: "Hipo/hiperpotasemia/metabólicas",
    EN: "Hypo/hyperkalemia/metabolic",
    IT: "Ipo/iperkaliemia/metaboliche",
    PT: "Hipo/hipercalemia/metabólica",
  },
  {
    id: "Hipo/Hipertermia",
    ES: "Hipo/Hipertermia",
    EN: "Hypo/hyperthermia",
    IT: "Ipo/Ipertermia",
    PT: "Hipo/hipertermia",
  },
  {
    id: "Trombosis coronaria/pulmonar",
    ES: "Trombosis coronaria/pulmonar",
    EN: "Thrombosis Coronary/pulmonary",
    IT: "Trombosi coronarica/polmonare",
    PT: "Trombose coronária/pulmonar",
  },
  {
    id: "Neumotórax a tensión",
    ES: "Neumotórax a tensión",
    EN: "Tension pneumothorax",
    IT: "Pneumotorace iperteso",
    PT: "Pneumotórax hipertensivo",
  },
  {
    id: "Taponamiento cardiaco",
    ES: "Taponamiento cardiaco",
    EN: "Tamponade cardiac",
    IT: "Tamponamento cardiaco",
    PT: "Tamponamento cardíaco",
  },
  {
    id: "Tóxicos",
    ES: "Tóxicos",
    EN: "Toxins",
    IT: "Sostanze tossiche",
    PT: "Tóxicos",
  },
  {
    id: "ecgRitmoPaciente",
    ES: "Ritmo ECG paciente",
    EN: "ECG rhythm patient",
    IT: "Ritmo ECG paciente",
    PT: "Ritmo ECG doente",
  },
  {
    id: "Asistolia",
    ES: "Asistolia",
    EN: "Asystole",
    IT: "Asistolia",
    PT: "Assistolia",
  },
  {
    id: "Actividad eléctrica sin pulso",
    ES: "Actividad eléctrica sin pulso",
    EN: "Pulseless electrical activity",
    IT: "Attività elettrica senza polso",
    PT: "Atividade elétrica sem pulso",
  },
  {
    id: "Fibrilación ventricular",
    ES: "Fibrilación ventricular",
    EN: "Ventricular fibrillation",
    IT: "Fibrillazione ventricolare",
    PT: "Fibrilação ventricular",
  },
  {
    id: "Taquicardia ventricular sin pulso",
    ES: "Taquicardia ventricular sin pulso",
    EN: "Pulseless ventricular tachycardia",
    IT: "Tachicardia ventricolare senza polso",
    PT: "Taquicardia ventricular sem pulso",
  },
  {
    id: "Torsaide de Pointes",
    ES: "Torsaide de Pointes",
    EN: "Torsaide de Pointes",
    IT: "Torsaide de Pointes",
    PT: "Torsade de Pointes",
  },
  {
    id: "Taquicardia ventricular con pulso",
    ES: "Taquicardia ventricular con pulso",
    EN: "Ventricular tachycardia with a pulse",
    IT: "Tachicardia ventricolare con polso",
    PT: "Taquicardia ventricular com pulso",
  },
  {
    id: "Bloqueo de 1er grado",
    ES: "Bloqueo de 1er grado",
    EN: "1st degree block",
    IT: "Blocco 1° grado",
    PT: "Bloqueio de 1º grau",
  },
  {
    id: "Bloqueo de 2º Mobitz I",
    ES: "Bloqueo de 2º Mobitz I",
    EN: "2nd degree block Mobitz I",
    IT: "2° blocco Mobitz I",
    PT: "2º Bloqueio Mobitz I",
  },
  {
    id: "Bloqueo de 2º Mobitz II",
    ES: "Bloqueo de 2º Mobitz II",
    EN: "2nd degree block Mobitz II",
    IT: "2° blocco Mobitz II",
    PT: "2º Bloqueio Mobitz II",
  },
  {
    id: "Bloque de 3er grado",
    ES: "Bloque de 3er grado",
    EN: "3rd degree block",
    IT: "Blocco 3°",
    PT: "Bloqueio de 3º grau",
  },
  {
    id: "Taquicardia supraventricular",
    ES: "Taquicardia supraventricular",
    EN: "Supraventricular tachycardia",
    IT: "Tachicardia sopraventricolare",
    PT: "Taquicardia supraventricular",
  },
  {
    id: "Ritmo sinusal",
    ES: "Ritmo sinusal",
    EN: "Sinus rhythm",
    IT: "Ritmo sinusale",
    PT: "Ritmo sinusal",
  },
  {
    id: "tecnicasFarmacos",
    ES: "Técnicas y Fármacos",
    EN: "Techniques and drugs",
    IT: "Tecniche e farmaci",
    PT: "Técnicas e medicamentos",
  },
  {
    id: "Técnicas",
    ES: "Técnicas",
    EN: "Techniques",
    IT: "Tecniche",
    PT: "Técnicas",
  },
  {
    id: "Cánula de guedel",
    ES: "Cánula de guedel",
    EN: "Guedel cannula",
    IT: "Cannula di Guedel",
    PT: "Cânula de Guedel",
  },
  {
    id: "Aspiración de secreciones",
    ES: "Aspiración de secreciones",
    EN: "Aspiration of secretions",
    IT: "Aspirazione di secrezioni",
    PT: "Aspiração de secreções",
  },
  {
    id: "Transfusión de hemoderivados",
    ES: "Transfusión de hemoderivados",
    EN: "Transfusion of blood products",
    IT: "Trasfusione di prodotti ematici",
    PT: "Transfusão de produtos sanguíneos",
  },
  {
    id: "Calentamiento paciente",
    ES: "Calentamiento paciente",
    EN: "Rewarming",
    IT: "Riscaldamento del paziente",
    PT: "Aquecimento do doente",
  },
  {
    id: "Enfriamiento paciente",
    ES: "Enfriamiento paciente",
    EN: "Cooling",
    IT: "Raffreddamento del paziente",
    PT: "Arrefecimento do doente",
  },
  {
    id: "Drenaje pleural",
    ES: "Drenaje pleural",
    EN: "Chest tube drainage",
    IT: "Drenaggio pleurico",
    PT: "Drenagem pleural",
  },
  {
    id: "Trombolisis",
    ES: "Trombolisis",
    EN: "Thrombolysis",
    IT: "Trombolisi",
    PT: "Trombólise",
  },
  {
    id: "Angiografía coronaria",
    ES: "Angiografía coronaria",
    EN: "Coronary angiography",
    IT: "Angiografia coronarica",
    PT: "Angiografia coronária",
  },
  {
    id: "Pericardiocentesis",
    ES: "Pericardiocentesis",
    EN: "Pericardiocentesis",
    IT: "Pericardiocentesi",
    PT: "Pericardiocentese",
  },
  {
    id: "Antídoto",
    ES: "Antídoto",
    EN: "Antidote",
    IT: "Antidoto",
    PT: "Antídoto",
  },
  {
    id: "Canaliación vía central",
    ES: "Canaliación vía central",
    EN: "Central line placement",
    IT: "Incannulamento vena centrale",
    PT: "Canulação de linha central",
  },
  {
    id: "Cardioversión",
    ES: "Cardioversión",
    EN: "Cardioversion",
    IT: "Cardioversione",
    PT: "Cardioversão",
  },
  {
    id: "Marcapasos externo",
    ES: "Marcapasos externo",
    EN: "Transcutaneous pacing",
    IT: "Pacing transcutaneo esterno",
    PT: "Marcapasso externo",
  },
  { id: "ECG", ES: "ECG", EN: "ECG", IT: "ECG", PT: "ECG" },
  {
    id: "Fármacos",
    ES: "Fármacos",
    EN: "Drugs",
    IT: "Farmaci",
    PT: "Medicamentos",
  },
  {
    id: "Adenosina",
    ES: "Adenosina",
    EN: "Adenosine",
    IT: "Adenosina",
    PT: "Adenosina",
  },
  {
    id: "Bicarbonato sódico",
    ES: "Bicarbonato sódico",
    EN: "Sodium bicarbonate",
    IT: "Bicarbonato di sodio",
    PT: "Bicarbonato de sódio",
  },
  {
    id: "Cloruro de Calcio",
    ES: "Cloruro de Calcio",
    EN: "Calcium chloride",
    IT: "Cloruro di calcio",
    PT: "Cloreto de cálcio",
  },
  {
    id: "Diazepam",
    ES: "Diazepam",
    EN: "Diazepam",
    IT: "Diazepam",
    PT: "Diazepam",
  },
  {
    id: "Flumazenilo",
    ES: "Flumazenilo",
    EN: "Flumazenil",
    IT: "Flumazenil",
    PT: "Flumazenil",
  },
  {
    id: "Lidocaína",
    ES: "Lidocaína",
    EN: "Lidocaine",
    IT: "Lidocaina",
    PT: "Lidocaína",
  },
  {
    id: "Sulfato de magnesio",
    ES: "Sulfato de magnesio",
    EN: "Magnesium sulphate",
    IT: "Solfato di magnesio",
    PT: "Sulfato de magnésio",
  },
  {
    id: "Naloxona",
    ES: "Naloxona",
    EN: "Naloxone",
    IT: "Naloxone",
    PT: "Naloxona",
  },
  {
    id: "Nitroglicerina",
    ES: "Nitroglicerina",
    EN: "Nitroglycerin",
    IT: "Nitroglicerina",
    PT: "Nitroglicerina",
  },
  {
    id: "Potasio",
    ES: "Potasio",
    EN: "Potassium",
    IT: "Potassio",
    PT: "Potássio",
  },
  { id: "Notas", ES: "Notas", EN: "Notes", IT: "Note", PT: "Notas" },
  {
    id: "informe",
    ES: "Informe",
    EN: "Report",
    IT: "Rapporto",
    PT: "Relatório",
  },
  { id: "Básico", ES: "Básico", EN: "Basic", IT: "Di base", PT: "Básico" },
  {
    id: "Escenario seguro",
    ES: "Escenario seguro",
    EN: "Scene safety",
    IT: "Scenario sicuro",
    PT: "Cenário seguro",
  },
  {
    id: "Grita ayuda",
    ES: "Grita ayuda",
    EN: "Shout for help",
    IT: "Grida aiuto",
    PT: "Pedido de ajuda",
  },
  {
    id: "Comprueba consciencia",
    ES: "Comprueba consciencia",
    EN: "Check for responsiveness",
    IT: "Verificare lo stato di coscienza",
    PT: "Verificar a consciência",
  },
  {
    id: "Abre vía aérea",
    ES: "Abre vía aérea",
    EN: "Open airway",
    IT: "Aprire le vie aeree",
    PT: "Abrir vias aéreas",
  },
  {
    id: "Comprueba ventilación",
    ES: "Comprueba ventilación",
    EN: "Check ventilation",
    IT: "Controllare la ventilazione",
    PT: "Verificar a ventilação",
  },
  {
    id: "Avisa equipo emergencias",
    ES: "Avisa equipo emergencias",
    EN: "Call emergency services",
    IT: "Chiama team di emergenza",
    PT: "Alertar a equipa de emergência",
  },
  {
    id: "Coloca DEA",
    ES: "Coloca DEA",
    EN: "Attaches AED",
    IT: "Posiziona il DAE",
    PT: "Coloca DEA",
  },
  { id: "Descarga", ES: "Descarga", EN: "Shock", IT: "Shock", PT: "Choque" },
  {
    id: "Posición lateral de seguridad",
    ES: "Posición lateral de seguridad",
    EN: "Recovery position",
    IT: "Posizione laterale di sicurezza",
    PT: "Posição lateral de segurança",
  },
  { id: "OVACE", ES: "OVACE", EN: "FBAO", IT: "OVACE", PT: "OVACE" },
  {
    id: "Incompleta",
    ES: "Incompleta",
    EN: "Incomplete",
    IT: "Incompleto",
    PT: "Incompleto",
  },
  {
    id: "Completa",
    ES: "Completa",
    EN: "Complete",
    IT: "Completo",
    PT: "Completa",
  },
  {
    id: "Inconsciente",
    ES: "Inconsciente",
    EN: "Unconscious",
    IT: "Incosciente",
    PT: "Inconsciente",
  },
  {
    id: "Consciente",
    ES: "Consciente",
    EN: "Conscious",
    IT: "Consciente",
    PT: "Consciente",
  },
  {
    id: "Animar a toser",
    ES: "Animar a toser",
    EN: "Encourage cough",
    IT: "Incoraggiare la tosse",
    PT: "Incentivar a tosse",
  },
  {
    id: "Golpes espalda",
    ES: "Golpes espalda",
    EN: "Back blows",
    IT: "Colpi alla schiena",
    PT: "Golpes nas costas",
  },
  {
    id: "Compresiones abdominales",
    ES: "Compresiones abdominales",
    EN: "Abdominal thrusts",
    IT: "Compressioni addominali",
    PT: "Compressões abdominais",
  },
  {
    id: "Compresiones torácicas",
    ES: "Compresiones torácicas",
    EN: "Chest compressions",
    IT: "Compressioni toraciche",
    PT: "Compressões torácicas",
  },
  {
    id: "Inicia soporte vital básico",
    ES: "Inicia soporte vital básico",
    EN: "Start basic life support",
    IT: "Iniziare supporto vitale di base",
    PT: "Iniciar o suporte básico de vida",
  },
  {
    id: "homeTitle",
    ES: "¿Qué vas a simular?",
    EN: "What will you simulate?",
    IT: "Cosa si intende simulare?",
    PT: "O que é que vai simular?",
  },
  {
    id: "avancedLifeSupport",
    ES: "Soporte vital avanzado",
    EN: "Advanced Life Support",
    IT: "Supporto vitale avanzato",
    PT: "Suporte avançado de vida",
  },
  {
    id: "Soporte vital básico + DEA",
    ES: "Soporte vital básico + DEA",
    EN: "Basic Life Support + AED",
    IT: "Supporto vitale di base + DAE",
    PT: "Suporte Básico de Vida + DEA",
  },
  {
    id: "Informes",
    ES: "Informes",
    EN: "Reports",
    IT: "Segnalazione",
    PT: "Relatórios",
  },
  {
    id: "dialogHabilidadesTitle",
    ES: "¿Desea medir alguno de estos parámetros?",
    EN: "What parameter do you want to measure?",
    IT: "Quale parametro vuoi misurare?",
    PT: "Qual o parâmetro que quer medir?",
  },
  { id: "yes", ES: "Sí", EN: "Yes", IT: "Sì", PT: "Sim" },
  { id: "No", ES: "No", EN: "No", IT: "No", PT: "Não" },
  {
    id: "Claridad de papeles",
    ES: "Claridad de papeles",
    EN: "Role clarity",
    IT: "Chiarezza del ruolo",
    PT: "Clareza de papéis",
  },
  {
    id: "Comunicación",
    ES: "Comunicación",
    EN: "Communication",
    IT: "Comunicazione",
    PT: "Comunicação",
  },
  {
    id: "Pedir ayuda precoz",
    ES: "Pedir ayuda precoz",
    EN: "Asking for early help",
    IT: "Ricerca di aiuto precoce",
    PT: "Procura precoce de ajuda",
  },
  {
    id: "Uso de recursos",
    ES: "Uso de recursos",
    EN: "Use of resources",
    IT: "Utilizzo delle risorse",
    PT: "Utilização de recursos",
  },
  {
    id: "Evaluación global",
    ES: "Evaluación global",
    EN: "Overall assessment",
    IT: "Valutazione complessiva",
    PT: "Avaliação global",
  },
  {
    id: "No realiza",
    ES: "No realiza",
    EN: "Unsatisfactory",
    IT: "Non esegue",
    PT: "Não executa",
  },
  {
    id: "Realiza parcial",
    ES: "Realiza parcial",
    EN: "Satisfactory",
    IT: "Esegue parzialmente",
    PT: "Realiza parcialmente",
  },
  {
    id: "Realiza completo",
    ES: "Realiza completo",
    EN: "Outstanding",
    IT: "Esegue una prestazione completa",
    PT: "Efectua uma execução completa",
  },
  {
    id: "Medir habilidades no técnicas",
    ES: "Medir habilidades no técnicas",
    EN: "Measuring non-technical skills",
    IT: "Misurare le competenze non tecniche",
    PT: "Medição das competências não técnicas",
  },
  {
    id: "Medir calidad RCP",
    ES: "Medir calidad RCP",
    EN: "Measuring CPR quality",
    IT: "Misurare la qualità della RCP",
    PT: "Medição da qualidade da RCP",
  },
  {
    id: "Medir ambas",
    ES: "Medir ambas",
    EN: "Measuring both",
    IT: "Misurare entrambi",
    PT: "Medição de ambos",
  },
  {
    id: "No medir ninguna",
    ES: "No medir ninguna",
    EN: "Do not measure any",
    IT: "Non misurare alcun",
    PT: "Não medir nenhum",
  },
  { id: "Descargas", ES: "Descargas", EN: "Shocks", IT: "Shock", PT: "Shock" },
  {
    id: "Nº descargas",
    ES: "Nº descargas",
    EN: "No. of shocks",
    IT: "Numero de shock",
    PT: "N.º de choques",
  },
  {
    id: "Media entre descargas",
    ES: "Media entre descargas",
    EN: "Mean between shocks",
    IT: "Media tra gli shock",
    PT: "Média entre choques",
  },
  {
    id: "Pausa perishock",
    ES: "Pausa perishock",
    EN: "Pre-shock pause",
    IT: "Pausa pre-shock",
    PT: "Pausa perishock",
  },
  {
    id: "Pausa postshock",
    ES: "Pausa postshock",
    EN: "Post-shock pause",
    IT: "Pausa post-shock",
    PT: "Pausa post-shock",
  },
  {
    id: "Calidad RCP",
    ES: "Calidad RCP",
    EN: "Quality CPR",
    IT: "RCP di qualità",
    PT: "Qualidade RCP",
  },
  {
    id: "Tiempo RCP",
    ES: "Tiempo RCP",
    EN: "CPR time",
    IT: "Tempo di RCP",
    PT: "Tempo de RCP",
  },
  {
    id: "Compresiones",
    ES: "Compresiones",
    EN: "Compressions",
    IT: "Compressioni",
    PT: "Compressões",
  },
  {
    id: "Ventilaciones",
    ES: "Ventilaciones",
    EN: "Ventilations",
    IT: "Ventilazione",
    PT: "Ventilações",
  },
  {
    id: "Pausa RCP",
    ES: "Pausa RCP",
    EN: "CPR pause",
    IT: "Pausa RCP",
    PT: "Pausa na RCP",
  },
  {
    id: "Calidad",
    ES: "Calidad RCP",
    EN: "CPR Quality",
    IT: "Qualità RCP",
    PT: "Qualidade RCP",
  },
  {
    id: "Profundidad",
    ES: "Profundidad",
    EN: "Depth",
    IT: "Profondità",
    PT: "Profundidade",
  },
  {
    id: "Frecuencia",
    ES: "Frecuencia",
    EN: "Frequency",
    IT: "Frequenza",
    PT: "Frequência",
  },
  {
    id: "Liberación torácica",
    ES: "Liberación torácica",
    EN: "Chest release",
    IT: "Rilascio del torace",
    PT: "Libertação do tórax",
  },
  {
    id: "Posición",
    ES: "Posición",
    EN: "Position",
    IT: "Posizione",
    PT: "Posição",
  },
  {
    id: "Guardar",
    ES: "Guardar",
    EN: "Save",
    IT: "Salva",
    PT: "Guardar",
  },
  {
    id: "saveAndReturn",
    ES: "Guardar y volver",
    EN: "Save and return",
    IT: "Salvare e restituire",
    PT: "Guardar e regressar",
  },
  {
    id: "Informe del caso",
    ES: "Informe del caso",
    EN: "Case report",
    IT: "Rapporto sul caso",
    PT: "Relato de caso",
  },
  {
    id: "Ingrese el nombre para el informe",
    ES: "Ingrese el nombre para el informe",
    EN: "Enter the name for the report",
    IT: "Inserire il nome del rapporto",
    PT: "Introduzir o nome do relatório",
  },
  {
    id: "Guardar informe 24 horas",
    ES: "Guardar informe 24 horas",
    EN: "Save report 24 hours",
    IT: "Salvataggio del rapporto 24 ore",
    PT: "Guardar relatório 24 horas",
  },
  {
    id: "Guardar como PDF",
    ES: "Guardar como PDF",
    EN: "Save as PDF",
    IT: "Salva come PDF",
    PT: "Guardar como PDF",
  },
  {
    id: "Simulaciones",
    ES: "Simulaciones",
    EN: "Simulations",
    IT: "Simulazioni",
    PT: "Simulações",
  },
  { id: "Idioma", ES: "Idioma", EN: "Language", IT: "La lingua", PT: "Língua" },
  {
    id: "Acerca de",
    ES: "Acerca de",
    EN: "About us",
    IT: "Informazioni su di noi",
    PT: "Sobre nós",
  },
  {
    id: "Políticas de privacidad",
    ES: "Políticas de privacidad",
    EN: "Privacy Policy",
    IT: "Informativa sulla privacy",
    PT: "Política de privacidade",
  },
  {
    id: "Informes[T1]",
    ES: "Informes",
    EN: "Reports",
    IT: "Rapporti",
    PT: "Relatórios",
  },
  {
    id: "Cerrar sesión",
    ES: "Cerrar sesión",
    EN: "Log out",
    IT: "Disconnettersi",
    PT: "Terminar sessão",
  },
  {
    id: "Privacy[T1]",
    ES: "POLÍTICA DE PRIVACIDAD",
    EN: "PRIVACY POLICY",
    IT: "POLITICA SULLA PRIVACY",
    PT: "POLÍTICA DE PRIVACIDADE",
  },
  {
    id: "Privacy[P1]",
    ES: "El presente Política de Privacidad establece los términos en que SIMULARCP usa y protege la información que es proporcionada por sus usuarios al momento de utilizar su sitio web. Este entorno web está comprometido con la seguridad de los datos de sus usuarios. Cuando le pedimos llenar los campos de información personal con la cual usted pueda ser identificado, lo hacemos asegurando que sólo se empleará de acuerdo con los términos de este documento. Sin embargo, esta Política de Privacidad puede cambiar con el tiempo o ser actualizada por lo que le recomendamos y enfatizamos revisar continuamente esta página para asegurarse que está de acuerdo con dichos cambios.",
    EN: "This Privacy Policy sets forth the terms under which SIMULARCP uses and protects the information that is provided by its users when using its web site. This web environment is committed to the security of its users' data. When we ask you to provide personal information by which you can be identified, we do so with the assurance that it will only be used in accordance with the terms of this document. However, this Privacy Policy may change over time or be updated and we encourage and emphasize that you should continually review this page to ensure that you agree to any such changes.",
    IT: "La presente Informativa sulla privacy stabilisce i termini in base ai quali SIMULARCP utilizza e protegge le informazioni che l'utente ci fornisce quando utilizza questo sito web. Questo ambiente web si impegna a garantire la sicurezza dei dati dei propri utenti. Quando chiediamo all'utente di inserire informazioni personali con le quali può essere identificato, lo facciamo con la garanzia che saranno utilizzate solo in conformità con i termini di questo documento. Tuttavia, la presente Informativa sulla privacy può cambiare nel tempo o essere aggiornata e vi invitiamo a consultare continuamente questa pagina per assicurarvi di essere soddisfatti di tali modifiche.",
    PT: "A presente Política de Privacidade estabelece os termos em que a SIMULARCP utiliza e protege a informação que o utilizador nos fornece quando utiliza este website. Este ambiente web está comprometido com a segurança dos dados dos seus utilizadores. Quando pedimos ao utilizador que preencha informações pessoais através das quais possa ser identificado, fazemo-lo com a garantia de que as mesmas apenas serão utilizadas de acordo com os termos deste documento. No entanto, esta Política de Privacidade pode mudar com o tempo ou ser actualizada e encorajamos e sublinhamos que deve rever continuamente esta página para garantir que está satisfeito com tais alterações.",
  },
  {
    id: "Privacy[T2]",
    ES: "Información que es recogida",
    EN: "Information that is collected",
    IT: "Informazioni raccolte",
    PT: "Informações recolhidas",
  },
  {
    id: "Privacy[P2]",
    ES: "Nuestro sitio web podrá recoger información personal, por ejemplo: Nombre,  información de contacto como  su dirección de correo electrónico e información demográfica. Así mismo cuando sea necesario podrá ser requerida información específica. Los informes generados serán borrados en el plazo de 24 horas desde su realización.",
    EN: "Our website may collect personal information, for example: Name, contact information such as your email address and demographic information. Also, when necessary, specific information may be requested. The reports generated will be deleted within 24 hours of their completion.",
    IT: "Il nostro sito web può raccogliere informazioni personali, ad esempio: nome, informazioni di contatto come l'indirizzo e-mail e informazioni demografiche. Se necessario, possono essere richieste anche informazioni specifiche. I rapporti generati saranno cancellati entro 24 ore dal loro completamento.",
    PT: "O nosso sítio Web pode recolher informações pessoais, por exemplo: nome, informações de contacto, como o seu endereço de correio eletrónico e informações demográficas. Poderão também ser solicitadas informações específicas, quando necessário. Os relatórios gerados serão eliminados no prazo de 24 horas após a sua conclusão.",
  },
  {
    id: "Privacy[T3]",
    ES: "Uso de la información recogida",
    EN: "Use of Information Collected",
    IT: "Utilizzo delle informazioni raccolte",
    PT: "Utilização das informações recolhidas",
  },
  {
    id: "Privacy[P3]",
    ES: "Nuestro sitio web emplea la información con el fin de proporcionar el mejor servicio posible, particularmente para mantener un registro de usuarios y realizar métricas con fines estadísticos.",
    EN: "Our website uses the information in order to provide the best possible service, particularly to keep track of users and to perform metrics for statistical purposes.",
    IT: "Il nostro sito web utilizza le informazioni per fornire il miglior servizio possibile, in particolare per tenere traccia degli utenti e per eseguire metriche a fini statistici.",
    PT: "O nosso sítio Web utiliza as informações para prestar o melhor serviço possível, nomeadamente para acompanhar os utilizadores e efetuar medições para fins estatísticos. ",
  },
  {
    id: "Privacy[T4]",
    ES: "Cookies",
    EN: "Cookies",
    IT: "Cookie",
    PT: "Cookies",
  },
  {
    id: "Privacy[P4.1]",
    ES: "Una cookie se refiere a un fichero que es enviado con la finalidad de solicitar permiso para almacenarse en su ordenador, al aceptar dicho fichero se crea y la cookie sirve entonces para tener información respecto al tráfico web, y también facilita las futuras visitas a una web recurrente. Otra función que tienen las cookies es que con ellas las webs pueden reconocerte individualmente y por tanto brindarte el mejor servicio personalizado de su web.",
    EN: "A cookie refers to a file that is sent with the purpose of requesting permission to be stored on your computer, by accepting such a file is created and the cookie then serves to have information regarding web traffic, and also facilitates future visits to a recurring website. Another function that cookies have is that with them the websites can recognize you individually and therefore provide you with the best personalized service on their website.",
    IT: "Un cookie si riferisce a un file che viene inviato con lo scopo di chiedere il permesso di essere memorizzato sul computer dell'utente; dopo l'accettazione del file viene creato e il cookie viene quindi utilizzato per raccogliere informazioni sul traffico web, oltre a facilitare le visite future a un sito web ricorrente. Un'altra funzione dei cookie è che grazie ad essi i siti web possono riconoscervi individualmente e quindi fornirvi il miglior servizio personalizzato sul loro sito.",
    PT: "Um cookie refere-se a um ficheiro que é enviado com o objetivo de pedir autorização para ser armazenado no seu computador, após a aceitação do ficheiro este é criado e o cookie é então utilizado para recolher informações relativas ao tráfego na web, facilitando também futuras visitas a um website recorrente. Outra função dos cookies é que, com eles, os sítios Web podem reconhecê-lo individualmente e, assim, prestar-lhe o melhor serviço personalizado no seu sítio Web.",
  },
  {
    id: "Privacy[P4.2]",
    ES: "Nuestro sitio web emplea las cookies para poder identificar las páginas que son visitadas y su frecuencia. Esta información es empleada únicamente para análisis estadístico y después la información se elimina de forma permanente. Usted puede eliminar las cookies en cualquier momento desde su ordenador. Sin embargo, las cookies ayudan a proporcionar un mejor servicio de los sitios web, estás no dan acceso a información de su ordenador ni de usted, a menos de que usted así lo quiera y la proporcione directamente. Usted puede aceptar o negar el uso de cookies, sin embargo, la mayoría de los navegadores aceptan cookies automáticamente pues sirve para tener un mejor servicio web. También usted puede cambiar la configuración de su ordenador para declinar las cookies. Si se declinan es posible que no pueda utilizar algunos de nuestros servicios.",
    EN: "Our website uses cookies to identify the pages that are visited and their frequency. This information is used only for statistical analysis and then the information is permanently deleted. You can delete cookies at any time from your computer. However, cookies help provide a better service from websites, they do not give access to information about your computer or you, unless you choose to provide it directly. You can accept or deny the use of cookies, however, most browsers automatically accept cookies as it serves to have a better web service. You can also change the settings on your computer to decline cookies. If you decline cookies you may not be able to use some of our services.",
    IT: "Il nostro sito web utilizza i cookie per poter identificare le pagine visitate e la loro frequenza. Queste informazioni vengono utilizzate solo per analisi statistiche e poi vengono cancellate definitivamente. È possibile cancellare i cookie dal proprio computer in qualsiasi momento. Tuttavia, i cookie aiutano a fornire un servizio migliore dai siti web, ma non danno accesso a informazioni sul vostro computer o su di voi, a meno che non scegliate di fornirle direttamente. È possibile accettare o rifiutare l'uso dei cookie, tuttavia la maggior parte dei browser li accetta automaticamente per fornire un servizio web migliore. È inoltre possibile modificare le impostazioni del computer per rifiutare i cookie. Se rifiutate i cookie, potreste non essere in grado di utilizzare alcuni dei nostri servizi.",
    PT: "O nosso sítio Web utiliza cookies para poder identificar as páginas que são visitadas e com que frequência. Esta informação é utilizada apenas para análise estatística e depois é apagada permanentemente. Pode apagar os cookies do seu computador em qualquer altura. No entanto, os cookies ajudam a fornecer um melhor serviço dos sítios Web, não dão acesso a informações sobre o seu computador ou sobre si, a menos que opte por fornecê-las diretamente. Pode aceitar ou recusar a utilização de cookies, no entanto, a maioria dos navegadores aceita automaticamente os cookies para fornecer um melhor serviço Web. Também pode alterar as definições do seu computador para recusar os cookies. Se recusar os cookies, poderá não conseguir utilizar alguns dos nossos serviços.",
  },
  {
    id: "Privacy[T5]",
    ES: "Enlaces a Terceros",
    EN: "Links to Third Parties",
    IT: "Collegamenti a terze parti",
    PT: "Ligações a terceiros",
  },
  {
    id: "Privacy[P5]",
    ES: "Este sitio web pudiera contener enlaces a otros sitios que pudieran ser de su interés. Una vez que usted de clic en estos enlaces y abandone nuestra página, ya no tenemos control sobre al sitio al que es redirigido y por lo tanto no somos responsables de los términos y privacidad, ni de la protección de sus datos en esos otros sitios terceros. Dichos sitios están sujetos a sus propias políticas de privacidad por lo cual es recomendable que los consulte para confirmar que usted está de acuerdo con estas.",
    EN: "This website may contain links to other sites that may be of interest to you. Once you click on these links and leave our site, we no longer have control over the site to which you are redirected and therefore we are not responsible for the terms and privacy and data protection practices of such other third party sites. Those sites are subject to their own privacy policies and we recommend that you check with them to confirm that you agree with them.",
    IT: "Questo sito web può contenere link ad altri siti che potrebbero essere di vostro interesse. Una volta che l'utente clicca su questi link e lascia il nostro sito, non abbiamo più il controllo sul sito a cui viene reindirizzato e pertanto non siamo responsabili dei termini e delle pratiche di privacy e protezione dei dati di tali siti di terze parti. Tali siti sono soggetti alle loro politiche sulla privacy e vi consigliamo di verificare con loro se ne siete soddisfatti.",
    PT: "Este sítio Web pode conter ligações para outros sítios que podem ser do seu interesse. Quando clica nessas ligações e sai do nosso sítio, deixamos de ter controlo sobre o sítio para o qual é redireccionado e, por conseguinte, não somos responsáveis pelos termos e práticas de privacidade ou pela proteção dos seus dados nesses sítios de terceiros. Esses sítios estão sujeitos às suas próprias políticas de privacidade e recomendamos que os consulte para confirmar se está satisfeito com as mesmas.",
  },
  {
    id: "Privacy[T6]",
    ES: "Control de su información personal",
    EN: "Control of your personal information",
    IT: "Controllo delle informazioni personali",
    PT: "Controlo das informações pessoais do utilizador",
  },
  {
    id: "Privacy[P6.1]",
    ES: "En cualquier momento usted puede restringir la recopilación o el uso de la información personal que es proporcionada a nuestro sitio web.",
    EN: "At any time you may restrict the collection or use of personal information that is provided to our website.",
    IT: "L'utente può in qualsiasi momento limitare la raccolta o l'utilizzo delle informazioni personali fornite al nostro sito web.",
    PT: "O utilizador pode, a qualquer momento, restringir a recolha ou utilização de informações pessoais que lhe sejam fornecidas no nosso site. ",
  },
  {
    id: "Privacy[P6.2]",
    ES: "SIMULARCP no venderá, cederá ni distribuirá la información personal que es recopilada sin su consentimiento, salvo que sea requerido por un juez con un orden judicial. Recomendamos no introducir ninguna información de datos personales, ya que SIMULARCP no se responsabiliza del uso indebido de esos datos.",
    EN: "SIMULARCP will not sell, give away, or distribute the personal information that is collected without your consent, unless required by a court order. We recommend that you do not enter any personal data information, as SIMULARCP is not responsible for any misuse of such data.",
    IT: "SIMULARCP non venderà, cederà o distribuirà le informazioni personali raccolte senza il consenso dell'utente, a meno che non sia richiesto da un'ordinanza del tribunale. Si consiglia di non inserire dati personali, poiché SIMULARCP non è responsabile dell'uso improprio di tali dati.",
    PT: "A SIMULARCP não venderá, cederá ou distribuirá as informações pessoais recolhidas sem o seu consentimento, exceto se for obrigada a fazê-lo por ordem judicial. Recomendamos que não introduza qualquer informação de dados pessoais, pois a SIMULARCP não se responsabiliza pelo uso indevido desses dados.",
  },
  {
    id: "Privacy[P6.3]",
    ES: "SIMULARCP Se reserva el derecho de cambiar los términos de la presente Política de Privacidad en cualquier momento.",
    EN: "SIMULARCP reserves the right to change the terms of this Privacy Policy at any time.",
    IT: "SIMULARCP si riserva il diritto di modificare i termini della presente Informativa sulla privacy in qualsiasi momento.",
    PT: "A SIMULARCP reserva-se o direito de alterar os termos da presente Política de Privacidade em qualquer altura.",
  },
  {
    id: "NoTecnicas[T1]",
    ES: "HABILIDADES NO TÉCNICAS CRISIS RESOURCE MANAGEMENT (CRM)",
    EN: "NON-TECHNICAL CRISIS RESOURCE MANAGEMENT (CRM) SKILLS",
    IT: "COMPETENZE NON TECNICHE DI GESTIONE DELLE RISORSE DI CRISI (CRM)",
    PT: "COMPETÊNCIAS NÃO TÉCNICAS DE GESTÃO DE RECURSOS EM SITUAÇÕES DE CRISE (CRM)",
  },
  {
    id: "NoTecnicas[T2]",
    ES: "CLARIDAD DE PAPELES",
    EN: "CLARITY OF ROLES",
    IT: "CHIAREZZA DEI RUOLI",
    PT: "CLAREZA DE PAPÉIS",
  },
  {
    id: "NoTecnicas[P2]",
    ES: "Identificación del líder y roles de resto del equipo. Coordinación, toma de decisiones. Tareas asignadas.",
    EN: "Identification of the leader and roles of the rest of the team. Coordination, decision making. Assigned tasks.",
    IT: "Identificazione del leader e dei ruoli del resto del team. Coordinamento, processo decisionale. Compiti assegnati.",
    PT: "Identificação do líder e dos papéis do resto da equipa. Coordenação, tomada de decisões. Atribuição de tarefas.",
  },
  {
    id: "NoTecnicas[T3]",
    ES: "COMUNICACIÓN",
    EN: "COMMUNICATION",
    IT: "COMUNICAZIONE",
    PT: "COMUNICAÇÃO",
  },
  {
    id: "NoTecnicas[P3]",
    ES: "Efectiva y relevante, directa y explícita, en bucle cerrado y buen tono.",
    EN: "Effective and relevant, direct and explicit, closed loop and good tone.",
    IT: "Efficace e pertinente, diretta ed esplicita, a circuito chiuso e con un buon tono.",
    PT: "Eficaz e pertinente, direta e explícita, com um ciclo fechado e um bom tom.",
  },
  {
    id: "NoTecnicas[T4]",
    ES: "PEDIR AYUDA PRECOZ",
    EN: "ASK FOR EARLY HELP",
    IT: "CHIEDERE AIUTO TEMPESTIVAMENTE",
    PT: "PEDIR AJUDA ATEMPADAMENTE",
  },
  {
    id: "NoTecnicas[P4]",
    ES: "Buscar soporte precoz. Utilizar sistema SBAR para transmitir información relevante.",
    EN: "Seek early support. Use SBAR system to convey relevant information.",
    IT: "Cercare un aiuto tempestivo. Utilizzare il sistema SBAR per trasmettere informazioni pertinenti.",
    PT: "Procurar apoio atempadamente. Utilizar o sistema SBAR para transmitir informações relevantes.",
  },
  {
    id: "NoTecnicas[T5]",
    ES: "USO DE RECURSOS",
    EN: "USE OF RESOURCES",
    IT: "USO DELLE RISORSE",
    PT: "UTILIZAÇÃO DE RECURSOS",
  },
  {
    id: "NoTecnicas[P5]",
    ES: "Conocer el entorno y recursos materiales, tecnológicos, personales y cognitivos. ",
    EN: "Know the environment and material, technological, personal and cognitive resources. ",
    IT: "Conoscere l'ambiente e le risorse materiali, tecnologiche, personali e cognitive. ",
    PT: "Conhecer o ambiente e os recursos materiais, tecnológicos, pessoais e cognitivos. ",
  },
  {
    id: "NoTecnicas[T6]",
    ES: "EVALUACIÓN GLOBAL",
    EN: "GLOBAL ASSESSMENT",
    IT: "VALUTAZIONE GLOBALE",
    PT: "AVALIAÇÃO GLOBAL",
  },
  {
    id: "NoTecnicas[P6]",
    ES: "Tarea de todos. Conocer: ¿qué está pasando? ¿Cuál es el plan? ¿Orden de prioridades? ¿Por qué?¿Todo el equipo comparte el mismo modelo mental? ",
    EN: "Everyone's task. Know: What is happening?, What is the plan?, Order of priorities?, Why?, Does the whole team share the same mental model? ",
    IT: "Compito di tutti. Sapere: cosa sta succedendo?, qual è il piano?, l'ordine delle priorità?, perché?, l'intero team condivide lo stesso modello mentale? ",
    PT: "Tarefa de todos. Saber: o que está a acontecer?, qual é o plano?, ordem de prioridades?, porquê?, toda a equipa partilha o mesmo modelo mental? ",
  },
  {
    id: "about_title",
    ES: "¿Qué es SimulaRCP?",
    EN: "What is SimulaRCP?",
    IT: "Cos'è SimulaRCP?",
    PT: "O que é o SimulaRCP?",
  },
  {
    id: "about_description",
    ES: "SimulaRCP es una herramienta que permite registrar y objetivar en tiempo real las habilidades técnicas y no técnicas de alumnos y profesionales sanitarios durante simulaciones clínicas de paradas cardiorrespiratorias.",
    EN: "SimulaRCP is a tool that allows real-time recording and objective evaluation of students' technical and non-technical skills during clinical simulations of cardiac arrest.",
    IT: "SimulaRCP è uno strumento che consente di registrare e valutare in tempo reale le competenze tecniche e non tecniche degli studenti durante simulazioni cliniche di arresto cardiaco.",
    PT: "O SimulaRCP é uma ferramenta que permite registrar e avaliar em tempo real as competências técnicas e não técnicas dos alunos durante simulações clínicas de paragem cardiorrespiratória.",
  },
  {
    id: "applications_title",
    ES: "Aplicaciones",
    EN: "Applications",
    IT: "Applicazioni",
    PT: "Aplicações",
  },
  {
    id: "applications_description",
    ES: "Docencia: cursos de soporte vital, formación de estudiantes de ciencias de la salud, evaluación de habilidades.\nInvestigación: recopilación de datos y métricas con fines científicos.\nGestión: organización y seguimiento de casos clínicos reales.\nAsistencial: mejora de la calidad asistencial, seguridad del paciente y debriefing clínico.",
    EN: "Teaching: life support courses, training of health science students, skills evaluation.\nResearch: collection of data and metrics for scientific purposes.\nManagement: organization and tracking of real clinical cases.\nClinical: improving care quality, patient safety, and clinical debriefing.",
    IT: "Didattica: corsi di supporto vitale, formazione degli studenti di scienze della salute, valutazione delle competenze.\nRicerca: raccolta di dati e metriche per scopi scientifici.\nGestione: organizzazione e monitoraggio di casi clinici reali.\nAssistenza: miglioramento della qualità dell'assistenza, sicurezza del paziente e debriefing clinico.",
    PT: "Ensino: cursos de suporte vital, formação de estudantes de ciências da saúde, avaliação de competências.\nInvestigação: recolha de dados e métricas para fins científicos.\nGestão: organização e acompanhamento de casos clínicos reais.\nAssistencial: melhoria da qualidade assistencial, segurança do paciente e debriefing clínico.",
  },
  {
    id: "audience_title",
    ES: "Destinatarios",
    EN: "Target Audience",
    IT: "Destinatari",
    PT: "Destinatários",
  },
  {
    id: "audience_description",
    ES: "- Facultades de Ciencias de la Salud.\n- Profesionales sanitarios que usan simulación clínica.\n- Docentes en soporte vital avanzado.\n- Gestores sanitarios.",
    EN: "- Health Sciences faculties.\n- Healthcare professionals using clinical simulation.\n- Instructors in advanced life support.\n- Healthcare managers.",
    IT: "- Facoltà di Scienze della Salute.\n- Professionisti sanitari che utilizzano la simulazione clinica.\n- Docenti di supporto vitale avanzato.\n- Gestori sanitari.",
    PT: "- Faculdades de Ciências da Saúde.\n- Profissionais de saúde que utilizam simulação clínica.\n- Docentes em suporte vital avançado.\n- Gestores de saúde.",
  },
  {
    id: "authors_title",
    ES: "Autores",
    EN: "Authors",
    IT: "Autori",
    PT: "Autores",
  },
  {
    id: "authors_description",
    ES: "José Antonio Jiménez Hernández\nFrancisco José Villalba Gómez\n\nEquipo de desarrollo:\nMaría García Hernández (Diseño UX/UI)\nJuan Rico (Desarrollador)\nIsmael Sagredo (Desarrollador)",
    EN: "José Antonio Jiménez Hernández\nFrancisco José Villalba Gómez\n\nDevelopment Team:\nMaría García Hernández (UX/UI Design)\nJuan Rico (Developer)\nIsmael Sagredo (Developer)",
    IT: "José Antonio Jiménez Hernández\nFrancisco José Villalba Gómez\n\nTeam di sviluppo:\nMaría García Hernández (Design UX/UI)\nJuan Rico (Sviluppatore)\nIsmael Sagredo (Sviluppatore)",
    PT: "José Antonio Jiménez Hernández\nFrancisco José Villalba Gómez\n\nEquipa de desenvolvimento:\nMaría García Hernández (Design UX/UI)\nJuan Rico (Desenvolvedor)\nIsmael Sagredo (Desenvolvedor)",
  },
  {
    id: "navigation_warning_title",
    ES: "¿Abandonar simulación?",
    EN: "Leave simulation?",
    IT: "Abbandonare la simulazione?",
    PT: "Sair da simulação?",
  },
  {
    id: "navigation_warning_message",
    ES: "¿Estás seguro de que quieres abandonar? Los datos de la simulación se perderán.",
    EN: "Are you sure you want to leave? The simulation data will be lost.",
    IT: "Sei sicuro di voler uscire? I dati della simulazione andranno persi.",
    PT: "Tem certeza de que quer sair? Os dados da simulação serão perdidos.",
  },
  {
    id: "collaborators_title",
    ES: "Colaboradores",
    EN: "Collaborators",
    IT: "Collaboratori",
    PT: "Colaboradores",
  },
  {
    id: "collaborators_description",
    ES: "Colegio Oficial de Enfermería de la Región de Murcia\nSindicato de Enfermería SATSE",
    EN: "Official College of Nursing of the Region of Murcia\nNursing Union SATSE",
    IT: "Ordine Ufficiale degli Infermieri della Regione di Murcia\nSindacato degli Infermieri SATSE",
    PT: "Colégio Oficial de Enfermagem da Região de Múrcia\nSindicato de Enfermagem SATSE",
  },
  {
    id: "about",
    ES: "Acerca de",
    EN: "About us",
    IT: "Informazioni su di noi",
    PT: "Sobre nós",
  },
  { id: "save", ES: "Guardar", EN: "Save", IT: "Salva", PT: "Guardar" },
  {
    id: "patient_type_question",
    ES: "¿El paciente es pediátrico o adulto?",
    EN: "Is the patient pediatric or adult?",
    IT: "Il paziente è pediatrico o adulto?",
    PT: "O paciente é pediátrico ou adulto?",
  },
  {
    id: "initial_rhythm_question",
    ES: "¿Cuál es el ritmo inicial del paciente?",
    EN: "What is the patient's initial rhythm?",
    IT: "Qual è il ritmo iniziale del paziente?",
    PT: "Qual é o ritmo inicial do paciente?",
  },
  {
    id: "Confirmar",
    ES: "Confirmar",
    EN: "Confirm",
    IT: "Conferma",
    PT: "Confirmar",
  },
  {
    id: "Cancelar",
    ES: "Cancelar",
    EN: "Cancel",
    IT: "Annulla",
    PT: "Cancelar",
  },
  {
    id: "tech_skills_question",
    ES: "¿Desea medir las habilidades no técnicas y/o la calidad de las RCP?",
    EN: "Do you want to measure non-technical skills and/or CPR quality?",
    IT: "Vuoi misurare le competenze non tecniche e/o la qualità della RCP?",
    PT: "Deseja medir as competências não técnicas e/ou a qualidade da RCP?",
  },
  {
    ES: "Guardar y medir calidad RCP",
    EN: "Save and measure CPR quality",
    IT: "Salva e misura la qualità della RCP",
    PT: "Guardar e medir a qualidade da RCP",
    id: "saveAndMesureRCP",
  },
  { ES: "Volver", EN: "Back", IT: "Indietro", PT: "Voltar", id: "back" },
  { ES: "Déficit", EN: "Deficit", IT: "Deficit", PT: "Déficit", id: "Déficit" },
  {
    ES: "Adecuado",
    EN: "Adequate",
    IT: "Adeguato",
    PT: "Adequado",
    id: "Adecuado",
  },
  {
    ES: "Excelente",
    EN: "Excellent",
    IT: "Eccellente",
    PT: "Excelente",
    id: "Excelente",
  },
  {
    id: "install_app_title",
    ES: "Instalar SimulaRCP",
    EN: "Install SimulaRCP",
    IT: "Installa SimulaRCP",
    PT: "Instalar SimulaRCP",
  },
  {
    id: "install_app_description",
    ES: "Acceso directo desde tu pantalla de inicio",
    EN: "Quick access from your home screen",
    IT: "Accesso rapido dalla schermata principale",
    PT: "Acesso rápido da tela inicial",
  },
  {
    id: "install",
    ES: "Instalar",
    EN: "Install",
    IT: "Installa",
    PT: "Instalar",
  },
  {
    id: "not_now",
    ES: "Ahora no",
    EN: "Not now",
    IT: "Non ora",
    PT: "Agora não",
  },
  {
    ES: "Inicio caso",
    EN: "Start case",
    IT: "Inizio caso",
    PT: "Início do caso",
    id: "startCase",
  },
  {
    id: "Inicio caso",
    ES: "Inicio caso",
    EN: "Start case",
    IT: "Inizio caso",
    PT: "Início do caso",
  },
  {
    ES: "Fin caso",
    EN: "End case",
    IT: "Fine caso",
    PT: "Fim do caso",
    id: "endCase",
  },
  {
    ES: "Compresiones y ventilaciones",
    EN: "Compressions and ventilations",
    IT: "Compressioni e ventilazioni",
    PT: "Compressões e ventilações",
    id: "compressionsAndVentilations",
  },
  {
    id: "Compresiones y ventilaciones",
    ES: "Compresiones y ventilaciones",
    EN: "Compressions and ventilations",
    IT: "Compressioni e ventilazioni",
    PT: "Compressões e ventilações",
  },
  {
    ES: "Compresiones",
    EN: "Compressions",
    IT: "Compressioni",
    PT: "Compressões",
    id: "compressions",
  },
  {
    ES: "Ventilaciones",
    EN: "Ventilations",
    IT: "Ventilazioni",
    PT: "Ventilações",
    id: "ventilations",
  },
  {
    EN: "ECG rhythm",
    ES: "Ritmo ECG paciente",
    IT: "Ritmo ECG del paziente",
    PT: "Ritmo ECG do paciente",
    id: "patientRhythm",
  },
  {
    EN: "Evaluate rhythm",
    ES: "Evalúa ritmo",
    IT: "Valuta ritmo",
    PT: "Avaliar ritmo",
    id: "evaluateRhythm",
  },
  {
    EN: "CPR fraction",
    ES: "Fracción RCP",
    IT: "Frazione RCP",
    PT: "Fração RCP",
    id: "cprFraction",
  },
  {
    EN: "Under construction",
    ES: "En construcción",
    IT: "In costruzione",
    PT: "Em construção",
    id: "ovanceNotAvaliable",
  },
  {
    EN: "Close",
    ES: "Cerrar",
    IT: "Chiudi",
    PT: "Fechar",
    id: "close",
  },
  {
    id: "sureToDelete",
    ES: "¿Está seguro que desea eliminar el informe?",
    EN: "Are you sure you want to delete the report?",
    IT: "Sei sicuro di voler eliminare il rapporto?",
    PT: "Tem certeza de que deseja excluir o relatório?",
  },
  {
    id: "Borrar informe",
    ES: "Borrar informe",
    EN: "Delete report",
    IT: "Elimina rapporto",
    PT: "Excluir relatório",
  },
  {
    id: "Totales",
    ES: "Totales",
    EN: "Totals",
    IT: "Totali",
    PT: "Totais",
  },
  {
    id: "PCR",
    ES: "PCR",
    EN: "CPR",
    IT: "RCP",
    PT: "RCP",
  },
  {
    id: "advanced",
    EN: "Advanced",
    ES: "Avanzado",
    IT: "Advanced",
    PT: "Advanced",
  },
  { id: "basic", EN: "Basic", ES: "Básico", IT: "Basic", PT: "Basic" },
  { id: "ovace", EN: "OVACE", ES: "OVACE", IT: "OVACE", PT: "OVACE" },
  {
    id: "saveReport",
    EN: "Save Report",
    ES: "Guardar Informe",
    IT: "Save Report",
    PT: "Save Report",
  },
  {
    id: "Habilidades no técnicas",
    ES: "Habilidades no técnicas",
    EN: "Non-technical skills",
    IT: "Competenze non tecniche",
    PT: "Competências não técnicas",
  },
  {
    id: "Queremos conocer tu opinión sobre esta aplicación",
    ES: "Queremos conocer tu opinión sobre esta aplicación",
    EN: "We want to know your opinion about this application.",
    IT: "Vogliamo conoscere la tua opinione su questa applicazione",
    PT: "Queremos saber a sua opinião sobre esta aplicação",
  },
  {
    id: "Intuitiva",
    ES: "Intuitiva",
    EN: "Intuitive",
    IT: "Intuitiva",
    PT: "Intuitivo",
  },
  {
    id: "Agilidad",
    ES: "Agilidad",
    EN: "Agility",
    IT: "Agilità",
    PT: "Agilidade",
  },
  {
    id: "Utilidad",
    ES: "Utilidad",
    EN: "Usefulness",
    IT: "Utilità",
    PT: "Utilidade",
  },
  {
    id: "¿Recomendaría esta aplicación a alguien?",
    ES: "¿Recomendaría esta aplicación a alguien?",
    EN: "Would you recommend this app to someone?",
    IT: "Consiglieresti questa applicazione a qualcuno?",
    PT: "Recomendaria esta aplicação a alguém?",
  },
  {
    id: "Comentarios",
    ES: "Comentarios",
    EN: "Comments",
    IT: "Commenti",
    PT: "Comentários",
  },
  {
    id: "Enviar",
    ES: "Enviar",
    EN: "Send",
    IT: "Invia",
    PT: "Enviar",
  },
  {
    id: "Nivel de simulación",
    ES: "Nivel de simulación",
    EN: "Simulation level",
    IT: "Livello di simulazione",
    PT: "Nível de simulação",
  },
  {
    id: "¿Este paciente es portador de acceso vascular?",
    ES: "¿Este paciente es portador de acceso vascular?",
    EN: "Does this patient have vascular access?",
    IT: "Questo paziente è portatore di accesso vascolare?",
    PT: "Este paciente é portador de acesso vascular?",
  },
  {
    id: "Calidad de compresiones",
    ES: "Calidad de compresiones",
    EN: "Quality of compressions",
    IT: "Qualità delle compressioni",
    PT: "Qualidade das compressões",
  },
  {
    id: "¿Desea medir alguno de estos parámetros?",
    ES: "¿Desea medir alguno de estos parámetros?",
    EN: "Would you like to measure any of these parameters?",
    IT: "Desideri misurare uno di questi parametri?",
    PT: "Deseja medir algum destes parâmetros?",
  },
  {
    id: "Creadores",
    ES: "Creadores",
    EN: "Creators",
    IT: "I creatori",
    PT: "Criadores",
  },
  {
    id: "Bibliografía",
    ES: "Bibliografía",
    EN: "Bibliography",
    IT: "Bibliografia",
    PT: "Bibliografia",
  },
  {
    id: "Documentos",
    ES: "Documentos",
    EN: "Documents",
    IT: "Documentazione",
    PT: "Documentos",
  },
  {
    id: "Inicio de caso",
    ES: "Inicio de caso",
    EN: "Case home",
    IT: "Casa del caso",
    PT: "Início do caso",
  },
  {
    id: "Inicio PCR",
    ES: "Inicio PCR",
    EN: "PCR start",
    IT: "Inizio PCR",
    PT: "Início da PCR",
  },
  {
    id: "Avisa equipo emergencias",
    ES: "Avisa equipo emergencias",
    EN: "Notify emergency team",
    IT: "Avvisare la squadra di emergenza",
    PT: "Notificar a equipa de emergência",
  },
  {
    id: "Fracción RCP",
    ES: "Fracción RCP",
    EN: "Fraction CPR",
    IT: "Frazione CPR",
    PT: "Fração RCP",
  },
  {
    id: "Totales",
    ES: "Totales",
    EN: "Totals",
    IT: "Totale",
    PT: "Totais",
  },
  {
    id: "Ritmo paciente",
    ES: "Ritmo ECG paciente",
    EN: "ECG rhythm",
    IT: "Ritmo ECG del paziente",
    PT: "Ritmo ECG do paciente",
  },
  {
    id: "Total pausa RCP",
    ES: "Total pausa RCP",
    EN: "Total CPR pause",
    IT: "Totale pausa RCP",
    PT: "Pausa total da RCP",
  },
  {
    id: "Tiempos RCP",
    ES: "Tiempos RCP",
    EN: "CPR times",
    IT: "Tempi di RCP",
    PT: "Tempos de RCP",
  },
  {
    id: "Técnica RCP",
    ES: "Técnica RCP",
    EN: "CPR technique",
    IT: "Tecnica di RCP",
    PT: "Técnica de RCP",
  },
  {
    id: "PCR",
    ES: "PCR",
    EN: "CA",
    IT: "ACR",
    PT: "PCR",
  },
  {
    id: "RCP",
    ES: "RCP",
    EN: "CPR",
    IT: "RCP",
    PT: "RCP",
  },
  {
    id: "IOT",
    ES: "IOT",
    EN: "ETI",
    IT: "IE",
    PT: "EOT",
  },
  {
    id: "DSG",
    ES: "DSG",
    EN: "LMA",
    IT: "DS",
    PT: "DSG",
  },
  {
    id: "RCE",
    ES: "RCE",
    EN: "ROSC",
    IT: "ROSC",
    PT: "RCE",
  },
  {
    id: "AESP",
    ES: "AESP",
    EN: "PEA",
    IT: "PEA",
    PT: "AESP",
  },
  {
    id: "FV",
    ES: "FV",
    EN: "VF",
    IT: "FV",
    PT: "FV",
  },
  {
    id: "TVSP",
    ES: "TVSP",
    EN: "pVT",
    IT: "TVSP",
    PT: "TVSP",
  },
  {
    id: "OVACE",
    ES: "OVACE",
    EN: "FVAO",
    IT: "OVACE",
    PT: "OVACE",
  },
  {
    id: "TVCP",
    ES: "TVCP",
    EN: "pulseVT",
    IT: "TVCP",
    PT: "TVCP",
  },
  {
    id: "Bloq. 1º",
    ES: "Bloq. 1º",
    EN: "1st block",
    IT: "Blocco 1º",
    PT: "Bloq. 1º",
  },
  {
    id: "Bloq. 2º I",
    ES: "Bloq. 2º I",
    EN: "2nd I Block",
    IT: "Blocco 2º I",
    PT: "Bloq. 2ºI",
  },
  {
    id: "Bloq. 2º II",
    ES: "Bloq. 2º II",
    EN: "2nd II Block",
    IT: "Blocco 2º II",
    PT: "Bloq. 2ºII",
  },
  {
    id: "Bloq. 3º",
    ES: "Bloq. 3º",
    EN: "3rd Block",
    IT: "Blocco 3º",
    PT: "Bloq. 3º",
  },
  {
    id: "TSV",
    ES: "TSV",
    EN: "SVT",
    IT: "TSV",
    PT: "TSP",
  },
  {
    id: "Sinusal",
    ES: "Sinusal",
    EN: "Sinus",
    IT: "Sinusale",
    PT: "Sinusal",
  },
  // Acrónimos y sus significados
  {
    id: "acronyms_title",
    ES: "Acrónimos",
    EN: "Acronyms",
    IT: "Acronimi",
    PT: "Acrónimos",
  },
  {
    id: "acronyms_description",
    ES: "Glosario de acrónimos médicos utilizados en la aplicación",
    EN: "Glossary of medical acronyms used in the application",
    IT: "Glossario degli acronimi medici utilizzati nell'applicazione",
    PT: "Glossário de acrónimos médicos utilizados na aplicação",
  },
  // AESP
  {
    id: "AESP_meaning",
    ES: "Actividad eléctrica sin pulso",
    EN: "Pulseless electrical activity",
    IT: "Attività elettrica senza polso",
    PT: "Atividade elétrica sem pulso",
  },
  // Bloq. 1º
  {
    id: "Bloq1_meaning",
    ES: "Bloqueo de 1er grado",
    EN: "1st Degree block",
    IT: "Blocco di 1° grado",
    PT: "Bloqueio de 1º grau",
  },
  // Bloq. 2º I
  {
    id: "Bloq2I_meaning",
    ES: "Bloqueo 2º grado Mobitz I",
    EN: "Mobitz I 2nd degree block",
    IT: "Blocco di 2° grado Mobitz I",
    PT: "Bloqueio de 2º grau Mobitz I",
  },
  // Bloq. 2º II
  {
    id: "Bloq2II_meaning",
    ES: "Bloqueo 2º grado Mobitz II",
    EN: "Mobitz II 2nd degree block",
    IT: "Blocco di 2° grado Mobitz II",
    PT: "Bloqueio de 2º grau Mobitz II",
  },
  // Bloq. 3º
  {
    id: "Bloq3_meaning",
    ES: "Bloqueo 3er grado",
    EN: "3rd Degree block",
    IT: "Blocco di 3° grado",
    PT: "Bloqueio de 3º grau",
  },
  // DEA
  {
    id: "DEA_meaning",
    ES: "Desfibrilador semiautomático",
    EN: "Automated external defibrillator",
    IT: "Defibrillatore semiautomatico",
    PT: "Desfibrilhador semiautomático",
  },
  // DSG
  {
    id: "DSG_meaning",
    ES: "Dispositivo supraglótico",
    EN: "Supraglottic airway device",
    IT: "Dispositivo sopraglottico",
    PT: "Dispositivo supraglótico",
  },
  // ECG
  {
    id: "ECG_meaning",
    ES: "Electrocardiograma",
    EN: "Electrocardiogram",
    IT: "Elettrocardiogramma",
    PT: "Eletrocardiograma",
  },
  // FV
  {
    id: "FV_meaning",
    ES: "Fibrilación ventricular",
    EN: "Ventricular fibrillation",
    IT: "Fibrillazione ventricolare",
    PT: "Fibrilação ventricular",
  },
  // IOT
  {
    id: "IOT_meaning",
    ES: "Intubación endotraqueal",
    EN: "Endotracheal intubation",
    IT: "Intubazione endotracheale",
    PT: "Entubação endotraqueal",
  },
  // IOT/DSG
  {
    id: "IOT_DSG_meaning",
    ES: "Intubación orotraqueal/Dispositivo supraglótico",
    EN: "Orotracheal intubation/Supraglottic airway device",
    IT: "Intubazione endotracheale/Dispositivo sovraglottico",
    PT: "Intubação endotraqueal/Dispositivo supraglótico",
  },
  // OVACE
  {
    id: "OVACE_meaning",
    ES: "Obstrucción de la vía aérea por cuerpo extraño",
    EN: "Foreign-body airway obstruction",
    IT: "Ostruzione delle Vie Aeree da Corpo Estraneo",
    PT: "Obstrução das vias aéreas por corpos estranhos",
  },
  // PCR
  {
    id: "PCR_meaning",
    ES: "Parada cardiorrespiratoria",
    EN: "Cardiorespiratory arrest",
    IT: "Arresto cardiorespiratorio",
    PT: "Paragem cardiorrespiratória",
  },
  // RCE
  {
    id: "RCE_meaning",
    ES: "Recuperación de la circulación espontánea",
    EN: "Return of spontaneous circulation",
    IT: "Ritorno alla circolazione spontanea",
    PT: "Recuperação da circulação espontânea",
  },
  // RCP
  {
    id: "RCP_meaning",
    ES: "Reanimación cardiopulmonar",
    EN: "Cardiopulmonary resuscitation",
    IT: "Rianimazione cardiopolmonare",
    PT: "Reanimação cardiopulmonar",
  },
  // Sinusal
  {
    id: "Sinusal_meaning",
    ES: "Ritmo sinusal",
    EN: "Sinus rhythm",
    IT: "Ritmo sinusale",
    PT: "Ritmo sinusal",
  },
  // TSV
  {
    id: "TSV_meaning",
    ES: "Taquicardia supraventricular",
    EN: "Supraventricular tachycardia",
    IT: "Tachicardia sopraventricolare",
    PT: "Taquicardia supraventricular",
  },
  // TVCP
  {
    id: "TVCP_meaning",
    ES: "Taquicardia ventricular con pulso",
    EN: "Ventricular tachycardia with pulse",
    IT: "Tachicardia ventricolare con pulsazioni",
    PT: "Taquicardia ventricular com pulso",
  },
  {
    id: "TVSP_meaning",
    ES: "Taquicardia ventricular sin pulso",
    EN: "Pulseless ventricular tachycardia",
    IT: "Tachicardia ventricolare senza polso",
    PT: "Taquicardia ventricular sem pulso",
  },
  // Sección de Ayuda/Glosario
  {
    id: "help_title",
    ES: "Ayuda",
    EN: "Help",
    IT: "Aiuto",
    PT: "Ajuda",
  },
  {
    id: "help_description",
    ES: "Glosario de términos y guía de botones de la aplicación",
    EN: "Glossary of terms and button guide for the application",
    IT: "Glossario dei termini e guida ai pulsanti dell'applicazione",
    PT: "Glossário de termos e guia de botões da aplicação",
  },
  {
    id: "acronyms_section",
    ES: "Acrónimos",
    EN: "Acronyms",
    IT: "Acronimi",
    PT: "Acrónimos",
  },
  {
    id: "buttonology_section",
    ES: "Botonología",
    EN: "Buttonology",
    IT: "Botonologia",
    PT: "Botonologia",
  },
  {
    id: "buttonology_description",
    ES: "Explicación de la función de cada botón en la aplicación",
    EN: "Explanation of each button's function in the application",
    IT: "Spiegazione della funzione di ogni pulsante nell'applicazione",
    PT: "Explicação da função de cada botão na aplicação",
  },
  // Botones principales
  {
    id: "start_case_button",
    ES: "Iniciar caso",
    EN: "Start case",
    IT: "Avvia caso",
    PT: "Iniciar caso",
  },
                {
                id: "start_case_description",
                ES: "Comienza el caso clínico. Al pulsar este botón se abrirá una ventana solicitando indicar el ritmo cardiaco propuesto por el instructor para comenzar el escenario (siempre que no se haya indicado ya en el botón 'RITMO ECG PACIENTE'). Tras ello se iniciará un cronómetro que permitirá medir la duración del caso clínico.",
                EN: "Starts the clinical case. When this button is pressed, a window will open requesting to indicate the cardiac rhythm proposed by the instructor to begin the scenario (as long as it has not already been indicated in the 'PATIENT ECG RHYTHM' button). After that, a chronometer will start to measure the duration of the clinical case.",
                IT: "Inizia il caso clinico. Quando si preme questo pulsante si aprirà una finestra che richiede di indicare il ritmo cardiaco proposto dall'istruttore per iniziare lo scenario (purché non sia già stato indicato nel pulsante 'RITMO ECG PAZIENTE'). Dopo di che inizierà un cronometro per misurare la durata del caso clinico.",
                PT: "Inicia o caso clínico. Ao premir este botão abrir-se-á uma janela solicitando indicar o ritmo cardíaco proposto pelo instrutor para começar o cenário (sempre que não tenha sido já indicado no botão 'RITMO ECG PACIENTE'). Após isso iniciar-se-á um cronómetro que permitirá medir a duração do caso clínico.",
              },
  {
    id: "stop_case_button",
    ES: "Parar caso",
    EN: "Stop case",
    IT: "Fermare caso",
    PT: "Parar caso",
  },
  {
    id: "stop_case_description",
    ES: "Finaliza el caso clínico. Al pulsar este botón se detendrá el cronómetro y se abrirá una ventana donde el instructor podrá (si se desea) valorar habilidades no técnicas y la calidad de RCP.",
    EN: "Ends the clinical case. When this button is pressed, the chronometer will stop and a window will open where the instructor can (if desired) assess non-technical skills and CPR quality.",
    IT: "Termina il caso clinico. Quando si preme questo pulsante il cronometro si fermerà e si aprirà una finestra dove l'istruttore potrà (se lo desidera) valutare le competenze non tecniche e la qualità della RCP.",
    PT: "Finaliza o caso clínico. Ao premir este botão o cronómetro parará e abrir-se-á uma janela onde o instrutor poderá (se desejar) avaliar competências não técnicas e a qualidade da RCP.",
  },
  {
    id: "start_pcr_button",
    ES: "Iniciar PCR",
    EN: "Start CA",
    IT: "Avvia ACR",
    PT: "Iniciar PCR",
  },
  {
    id: "start_pcr_description",
    ES: "Comienza la situación de parada cardiorrespiratoria (PCR). El instructor puede decidir iniciar el caso clínico con un paciente ya en PCR o bien con un paciente que sufra una PCR a los minutos de comenzar el caso clínico. Al pulsar este botón, se iniciará un cronómetro que permitirá medir el tiempo total del paciente en PCR.",
    EN: "Begins the cardiac arrest (CA) situation. The instructor can decide to start the clinical case with a patient already in CA or with a patient who suffers a CA minutes after starting the clinical case. When this button is pressed, a chronometer will start to measure the total time the patient is in CA.",
    IT: "Inizia la situazione di arresto cardiaco (ACR). L'istruttore può decidere di iniziare il caso clinico con un paziente già in ACR o con un paziente che soffre di ACR minuti dopo aver iniziato il caso clinico. Quando si preme questo pulsante, inizierà un cronometro per misurare il tempo totale del paziente in ACR.",
    PT: "Começa a situação de paragem cardiorrespiratória (PCR). O instrutor pode decidir iniciar o caso clínico com um doente já em PCR ou com um doente que sofra uma PCR minutos após começar o caso clínico. Ao premir este botão, iniciar-se-á um cronómetro que permitirá medir o tempo total do doente em PCR.",
  },
  {
    id: "stop_pcr_button",
    ES: "Parar PCR",
    EN: "Stop CA",
    IT: "Fermare ACR",
    PT: "Parar PCR",
  },
  {
    id: "stop_pcr_description",
    ES: "Detiene la reanimación cardiopulmonar",
    EN: "Stops cardiopulmonary resuscitation",
    IT: "Ferma la rianimazione cardiopolmonare",
    PT: "Para a reanimação cardiopulmonar",
  },
  // Botones de ritmo
  {
    id: "patient_rhythm_button",
    ES: "Ritmo ECG paciente",
    EN: "ECG rhythm",
    IT: "Ritmo ECG del paziente",
    PT: "Ritmo ECG do paciente",
  },
  {
    id: "patient_rhythm_description",
    ES: "Permite evaluar y cambiar el ritmo cardíaco del paciente",
    EN: "Allows to evaluate and change the patient's cardiac rhythm",
    IT: "Permette di valutare e cambiare il ritmo cardiaco del paziente",
    PT: "Permite avaliar e alterar o ritmo cardíaco do paciente",
  },
  {
    id: "evaluate_rhythm_button",
    ES: "Evalúa ritmo",
    EN: "Evaluate rhythm",
    IT: "Valuta ritmo",
    PT: "Avaliar ritmo",
  },
  {
    id: "evaluate_rhythm_description",
    ES: "Evalúa el ritmo cardíaco actual del paciente",
    EN: "Evaluates the patient's current cardiac rhythm",
    IT: "Valuta il ritmo cardiaco attuale del paziente",
    PT: "Avalia o ritmo cardíaco atual do paciente",
  },
  // Botones de compresiones y ventilaciones
  {
    id: "start_compressions_button",
    ES: "Inicia compresiones",
    EN: "Start compressions",
    IT: "Avvia compressioni",
    PT: "Inicia compressões",
  },
  {
    id: "start_compressions_description",
    ES: "Inicia las compresiones torácicas",
    EN: "Starts chest compressions",
    IT: "Avvia le compressioni toraciche",
    PT: "Inicia as compressões torácicas",
  },
  {
    id: "stop_compressions_button",
    ES: "Detiene compresiones",
    EN: "Stop compressions",
    IT: "Ferma compressioni",
    PT: "Para compressões",
  },
  {
    id: "stop_compressions_description",
    ES: "Detiene las compresiones torácicas",
    EN: "Stops chest compressions",
    IT: "Ferma le compressioni toraciche",
    PT: "Para as compressões torácicas",
  },
  {
    id: "start_ventilations_button",
    ES: "Inicia ventilaciones",
    EN: "Start ventilations",
    IT: "Avvia ventilazioni",
    PT: "Inicia ventilações",
  },
  {
    id: "start_ventilations_description",
    ES: "Inicia las ventilaciones de rescate",
    EN: "Starts rescue ventilations",
    IT: "Avvia le ventilazioni di soccorso",
    PT: "Inicia as ventilações de socorro",
  },
  {
    id: "stop_ventilations_button",
    ES: "Detiene ventilaciones",
    EN: "Stop ventilations",
    IT: "Ferma ventilazioni",
    PT: "Para ventilações",
  },
  {
    id: "stop_ventilations_description",
    ES: "Detiene las ventilaciones de rescate",
    EN: "Stops rescue ventilations",
    IT: "Ferma le ventilazioni di soccorso",
    PT: "Para as ventilações de socorro",
  },
  // Botones de desfibrilación
  {
    id: "defibrillation_button",
    ES: "Desfibrilación",
    EN: "Defibrillation",
    IT: "Defibrillazione",
    PT: "Desfibrilação",
  },
  {
    id: "defibrillation_description",
    ES: "Aplica una descarga eléctrica para tratar arritmias",
    EN: "Applies an electrical shock to treat arrhythmias",
    IT: "Applica una scarica elettrica per trattare le aritmie",
    PT: "Aplica um choque elétrico para tratar arritmias",
  },
  // Botones de medicamentos
  {
    id: "adrenaline_button",
    ES: "Adrenalina",
    EN: "Adrenaline",
    IT: "Adrenalina",
    PT: "Adrenalina",
  },
  {
    id: "adrenaline_description",
    ES: "Administra adrenalina para tratar la PCR",
    EN: "Administers adrenaline to treat PCR",
    IT: "Somministra adrenalina per trattare la PCR",
    PT: "Administra adrenalina para tratar a PCR",
  },
  {
    id: "amiodarone_button",
    ES: "Amiodarona",
    EN: "Amiodarone",
    IT: "Amiodarone",
    PT: "Amiodarona",
  },
  {
    id: "amiodarone_description",
    ES: "Administra amiodarona para tratar arritmias",
    EN: "Administers amiodarone to treat arrhythmias",
    IT: "Somministra amiodarone per trattare le aritmie",
    PT: "Administra amiodarona para tratar arritmias",
  },
  // Botones de vía aérea
  {
    id: "intubation_button",
    ES: "Intubación",
    EN: "Intubation",
    IT: "Intubazione",
    PT: "Intubação",
  },
  {
    id: "intubation_description",
    ES: "Realiza intubación endotraqueal",
    EN: "Performs endotracheal intubation",
    IT: "Esegue intubazione endotracheale",
    PT: "Realiza intubação endotraqueal",
  },
  {
    id: "supraglottic_button",
    ES: "Dispositivo supraglótico",
    EN: "Supraglottic device",
    IT: "Dispositivo sopraglottico",
    PT: "Dispositivo supraglótico",
  },
  {
    id: "supraglottic_description",
    ES: "Coloca dispositivo supraglótico para vía aérea",
    EN: "Places supraglottic airway device",
    IT: "Posiziona dispositivo sopraglottico per via aerea",
    PT: "Coloca dispositivo supraglótico para via aérea",
  },
  // Botones de calidad
  {
    id: "quality_button",
    ES: "Calidad RCP",
    EN: "CPR Quality",
    IT: "Qualità RCP",
    PT: "Qualidade RCP",
  },
  {
    id: "quality_description",
    ES: "Evalúa la calidad de las compresiones y ventilaciones",
    EN: "Evaluates the quality of compressions and ventilations",
    IT: "Valuta la qualità delle compressioni e ventilazioni",
    PT: "Avalia a qualidade das compressões e ventilações",
  },
  // Botones de habilidades no técnicas
  {
    id: "non_technical_button",
    ES: "Habilidades no técnicas",
    EN: "Non-technical skills",
    IT: "Competenze non tecniche",
    PT: "Competências não técnicas",
  },
  {
    id: "non_technical_description",
    ES: "Evalúa habilidades de comunicación y liderazgo",
    EN: "Evaluates communication and leadership skills",
    IT: "Valuta le competenze di comunicazione e leadership",
    PT: "Avalia competências de comunicação e liderança",
  },
  // Botones de posición
  {
    id: "position_button",
    ES: "Posición",
    EN: "Position",
    IT: "Posizione",
    PT: "Posição",
  },
  {
    id: "position_description",
    ES: "Ajusta la posición del paciente para RCP",
    EN: "Adjusts patient position for CPR",
    IT: "Regola la posizione del paziente per RCP",
    PT: "Ajusta a posição do paciente para RCP",
  },
  // Botones de guardado
  {
    id: "save_button",
    ES: "Guardar",
    EN: "Save",
    IT: "Salva",
    PT: "Guardar",
  },
  {
    id: "save_description",
    ES: "Guarda el progreso actual del caso",
    EN: "Saves the current case progress",
    IT: "Salva il progresso attuale del caso",
    PT: "Guarda o progresso atual do caso",
  },
  {
    id: "save_report_button",
    ES: "Guardar informe",
    EN: "Save report",
    IT: "Salva rapporto",
    PT: "Guardar relatório",
  },
  {
    id: "save_report_description",
    ES: "Guarda el informe final del caso",
    EN: "Saves the final case report",
    IT: "Salva il rapporto finale del caso",
    PT: "Guarda o relatório final do caso",
  },
  // Botones de emergencia
  {
    id: "emergency_team_button",
    ES: "Avisa equipo emergencias",
    EN: "Notify emergency team",
    IT: "Avvisare la squadra di emergenza",
    PT: "Notificar a equipa de emergência",
  },
  {
    id: "emergency_team_description",
    ES: "Notifica al equipo de emergencias",
    EN: "Notifies the emergency team",
    IT: "Notifica la squadra di emergenza",
    PT: "Notifica a equipa de emergência",
  },
  // Botones de OVACE
  {
    id: "ovace_button",
    ES: "OVACE",
    EN: "FBAO",
    IT: "OVACE",
    PT: "OVACE",
  },
  {
    id: "ovace_description",
    ES: "Maneja obstrucción de vía aérea por cuerpo extraño",
    EN: "Manages foreign body airway obstruction",
    IT: "Gestisce ostruzione delle vie aeree da corpo estraneo",
    PT: "Maneja obstrução das vias aéreas por corpo estranho",
  },
  // Política de Privacidad
  {
    id: "privacy_policy_title",
    ES: "Política de Privacidad",
    EN: "Privacy Policy",
    IT: "Politica sulla Privacy",
    PT: "Política de Privivacidade",
  },
  {
    id: "privacy_policy_description",
    ES: "Información sobre el tratamiento de datos personales",
    EN: "Information about personal data processing",
    IT: "Informazioni sul trattamento dei dati personali",
    PT: "Informação sobre o tratamento de dados pessoais",
  },
  {
    id: "privacy_section_1_title",
    ES: "Compromiso con la Seguridad",
    EN: "Security Commitment",
    IT: "Impegno per la Sicurezza",
    PT: "Compromisso com a Segurança",
  },
  {
    id: "privacy_section_1_content",
    ES: "SIMULARCP usa y protege la información que es proporcionada por sus usuarios al momento de utilizar su sitio web. Este entorno web está comprometido con la seguridad de los datos de sus usuarios. Cuando le pedimos llenar los campos de información personal con la cual usted pueda ser identificado, lo hacemos asegurando que sólo se empleará de acuerdo con los términos de este documento.",
    EN: "SIMULARCP uses and protects the information that is provided by its users when using its website. This web environment is committed to the security of its users' data. When we ask you to fill in personal information fields by which you can be identified, we do so ensuring that it will only be used in accordance with the terms of this document.",
    IT: "SIMULARCP utilizza e protegge le informazioni che l'utente ci fornisce quando utilizza questo sito web. Questo ambiente web si impegna a garantire la sicurezza dei dati dei propri utenti. Quando chiediamo all'utente di inserire informazioni personali con le quali può essere identificato, lo facciamo con la garanzia che saranno utilizzate solo in conformità con i termini di questo documento.",
    PT: "A SIMULARCP utiliza e protege a informação que o utilizador nos fornece quando utiliza este website. Este ambiente web está comprometido com a segurança dos dados dos seus utilizadores. Quando pedimos ao utilizador que preencha informações pessoais através das quais possa ser identificado, fazemo-lo com a garantia de que as mesmas apenas serão utilizadas de acordo com os termos deste documento.",
  },
  {
    id: "privacy_section_2_title",
    ES: "Información Recogida",
    EN: "Information Collected",
    IT: "Informazioni Raccolte",
    PT: "Informação Recolhida",
  },
  {
    id: "privacy_section_2_content",
    ES: "Nuestro sitio web podrá recoger información personal, por ejemplo: Nombre, información de contacto como su dirección de correo electrónico e información demográfica. Así mismo cuando sea necesario podrá ser requerida información específica. Los informes generados serán borrados en el plazo de 24 horas desde su realización.",
    EN: "Our website may collect personal information, for example: Name, contact information such as your email address and demographic information. Also, when necessary, specific information may be requested. The reports generated will be deleted within 24 hours of their completion.",
    IT: "Il nostro sito web può raccogliere informazioni personali, ad esempio: nome, informazioni di contatto come l'indirizzo e-mail e informazioni demografiche. Se necessario, possono essere richieste anche informazioni specifiche. I rapporti generati saranno cancellati entro 24 ore dal loro completamento.",
    PT: "O nosso sítio Web pode recolher informações pessoais, por exemplo: nome, informações de contacto, como o seu endereço de correio eletrónico e informações demográficas. Poderão também ser solicitadas informações específicas, quando necessário. Os relatórios gerados serão eliminados no prazo de 24 horas após a sua conclusão.",
  },
  {
    id: "privacy_section_3_title",
    ES: "Uso de la Información",
    EN: "Use of Information",
    IT: "Uso delle Informazioni",
    PT: "Utilização da Informação",
  },
  {
    id: "privacy_section_3_content",
    ES: "Nuestro sitio web emplea la información con el fin de proporcionar el mejor servicio posible, particularmente para mantener un registro de usuarios y realizar métricas con fines estadísticos.",
    EN: "Our website uses the information in order to provide the best possible service, particularly to keep track of users and to perform metrics for statistical purposes.",
    IT: "Il nostro sito web utilizza le informazioni per fornire il miglior servizio possibile, in particolare per tenere traccia degli utenti e per eseguire metriche a fini statistici.",
    PT: "O nosso sítio Web utiliza as informações para prestar o melhor serviço possível, nomeadamente para acompanhar os utilizadores e efetuar medições para fins estatísticos.",
  },
  {
    id: "privacy_section_4_title",
    ES: "Cookies",
    EN: "Cookies",
    IT: "Cookie",
    PT: "Cookies",
  },
  {
    id: "privacy_section_4_content",
    ES: "Una cookie se refiere a un fichero que es enviado con la finalidad de solicitar permiso para almacenarse en su ordenador. Nuestro sitio web emplea las cookies para poder identificar las páginas que son visitadas y su frecuencia. Esta información es empleada únicamente para análisis estadístico y después la información se elimina de forma permanente.",
    EN: "A cookie refers to a file that is sent with the purpose of requesting permission to be stored on your computer. Our website uses cookies to identify the pages that are visited and their frequency. This information is used only for statistical analysis and then the information is permanently deleted.",
    IT: "Un cookie si riferisce a un file che viene inviato con lo scopo di chiedere il permesso di essere memorizzato sul computer dell'utente. Il nostro sito web utilizza i cookie per poter identificare le pagine visitate e la loro frequenza. Queste informazioni vengono utilizzate solo per analisi statistiche e poi vengono cancellate definitivamente.",
    PT: "Um cookie refere-se a um ficheiro que é enviado com o objetivo de pedir autorização para ser armazenado no seu computador. O nosso sítio Web utiliza cookies para poder identificar as páginas que são visitadas e com que frequência. Esta informação é utilizada apenas para análise estatística e depois é apagada permanentemente.",
  },
  {
    id: "privacy_section_5_title",
    ES: "Control de Información",
    EN: "Information Control",
    IT: "Controllo delle Informazioni",
    PT: "Controlo da Informação",
  },
  {
    id: "privacy_section_5_content",
    ES: "En cualquier momento usted puede restringir la recopilación o el uso de la información personal que es proporcionada a nuestro sitio web. SIMULARCP no venderá, cederá ni distribuirá la información personal que es recopilada sin su consentimiento, salvo que sea requerido por un juez con un orden judicial.",
    EN: "At any time you may restrict the collection or use of personal information that is provided to our website. SIMULARCP will not sell, give away, or distribute the personal information that is collected without your consent, unless required by a court order.",
    IT: "L'utente può in qualsiasi momento limitare la raccolta o l'utilizzo delle informazioni personali fornite al nostro sito web. SIMULARCP non venderà, cederà o distribuirà le informazioni personali raccolte senza il consenso dell'utente, a meno che non sia richiesto da un'ordinanza del tribunale.",
    PT: "O utilizador pode, a qualquer momento, restringir a recolha ou utilização de informações pessoais que lhe sejam fornecidas no nosso site. A SIMULARCP não venderá, cederá ou distribuirá as informações pessoais recolhidas sem o seu consentimento, exceto se for obrigada a fazê-lo por ordem judicial.",
  },
  {
    id: "privacy_section_6_title",
    ES: "Cambios en la Política",
    EN: "Policy Changes",
    IT: "Modifiche alla Politica",
    PT: "Alterações à Política",
  },
  {
    id: "privacy_section_6_content",
    ES: "SIMULARCP se reserva el derecho de cambiar los términos de la presente Política de Privacidad en cualquier momento. Esta Política de Privacidad puede cambiar con el tiempo o ser actualizada por lo que le recomendamos y enfatizamos revisar continuamente esta página para asegurarse que está de acuerdo con dichos cambios.",
    EN: "SIMULARCP reserves the right to change the terms of this Privacy Policy at any time. This Privacy Policy may change over time or be updated and we encourage and emphasize that you should continually review this page to ensure that you agree to any such changes.",
    IT: "SIMULARCP si riserva il diritto di modificare i termini della presente Informativa sulla privacy in qualsiasi momento. La presente Informativa sulla privacy può cambiare nel tempo o essere aggiornata e vi invitiamo a consultare continuamente questa pagina per assicurarvi di essere soddisfatti di tali modifiche.",
    PT: "A SIMULARCP reserva-se o direito de alterar os termos da presente Política de Privacidade em qualquer altura. Esta Política de Privacidade pode mudar com o tempo ou ser actualizada e encorajamos e sublinhamos que deve rever continuamente esta página para garantir que está satisfeito com tais alterações.",
  },
  {
    id: "privacy_last_updated",
    ES: "Última actualización:",
    EN: "Last updated:",
    IT: "Ultimo aggiornamento:",
    PT: "Última atualização:",
  },
  // Feedback
  {
    id: "feedback_title",
    ES: "Queremos conocer tu opinión",
    EN: "We want to know your opinion",
    IT: "Vogliamo conoscere la tua opinione",
    PT: "Queremos conhecer a tua opinião",
  },
  {
    id: "feedback_subtitle",
    ES: "Tu opinión nos ayuda a mejorar esta aplicación",
    EN: "Your opinion helps us improve this application",
    IT: "La tua opinione ci aiuta a migliorare questa applicazione",
    PT: "A tua opinião ajuda-nos a melhorar esta aplicação",
  },
  {
    id: "feedback_intuitive",
    ES: "Intuitiva",
    EN: "Intuitive",
    IT: "Intuitiva",
    PT: "Intuitiva",
  },
  {
    id: "feedback_agility",
    ES: "Agilidad",
    EN: "Agility",
    IT: "Agilità",
    PT: "Agilidade",
  },
  {
    id: "feedback_usefulness",
    ES: "Utilidad",
    EN: "Usefulness",
    IT: "Utilità",
    PT: "Utilidade",
  },
  {
    id: "feedback_recommendation",
    ES: "¿Recomendaría esta aplicación a alguien?",
    EN: "Would you recommend this application to someone?",
    IT: "Raccomanderesti questa applicazione a qualcuno?",
    PT: "Recomendaria esta aplicação a alguém?",
  },
  {
    id: "feedback_yes",
    ES: "Sí",
    EN: "Yes",
    IT: "Sì",
    PT: "Sim",
  },
  {
    id: "feedback_no",
    ES: "No",
    EN: "No",
    IT: "No",
    PT: "Não",
  },
  {
    id: "feedback_comments",
    ES: "Comentarios",
    EN: "Comments",
    IT: "Commenti",
    PT: "Comentários",
  },
  {
    id: "feedback_comments_placeholder",
    ES: "Escribe tus comentarios aquí...",
    EN: "Write your comments here...",
    IT: "Scrivi i tuoi commenti qui...",
    PT: "Escreva os seus comentários aqui...",
  },
  {
    id: "feedback_send",
    ES: "Enviar",
    EN: "Send",
    IT: "Invia",
    PT: "Enviar",
  },
  {
    id: "feedback_sending",
    ES: "Enviando...",
    EN: "Sending...",
    IT: "Invio in corso...",
    PT: "A enviar...",
  },
  {
    id: "feedback_success",
    ES: "¡Gracias por tu feedback!",
    EN: "Thank you for your feedback!",
    IT: "Grazie per il tuo feedback!",
    PT: "Obrigado pelo seu feedback!",
  },
  {
    id: "feedback_error",
    ES: "Error al enviar el feedback. Inténtalo de nuevo.",
    EN: "Error sending feedback. Please try again.",
    IT: "Errore nell'invio del feedback. Riprova.",
    PT: "Erro ao enviar o feedback. Tente novamente.",
  },
  {
    id: "feedback_required",
    ES: "Por favor, completa al menos una calificación",
    EN: "Please complete at least one rating",
    IT: "Per favore, completa almeno una valutazione",
    PT: "Por favor, complete pelo menos uma avaliação",
  },
  // Botones específicos de botonología
  {
    id: "rce_button",
    ES: "RCE",
    EN: "ROSC",
    IT: "RCE",
    PT: "RCE",
  },
  {
    id: "rce_description",
    ES: "Al pulsar este botón estaremos indicando que el paciente ha recuperado la circulación espontánea.",
    EN: "When this button is pressed, we will be indicating that the patient has recovered spontaneous circulation.",
    IT: "Quando si preme questo pulsante, indicheremo che il paziente ha recuperato la circolazione spontanea.",
    PT: "Ao premir este botão estaremos a indicar que o doente recuperou a circulação espontânea.",
  },
  {
    id: "vascular_access_button",
    ES: "Acceso vascular",
    EN: "Vascular access",
    IT: "Accesso vascolare",
    PT: "Acesso vascular",
  },
  {
    id: "vascular_access_description",
    ES: "El escenario puede comenzar con el paciente siendo ya portador de vía venosa periférica (VVP) o con el paciente precisando canalización de VVP en algún momento de la simulación. Por tanto, podremos seleccionar este botón antes de comenzar el escenario o durante el mismo.",
    EN: "The scenario can begin with the patient already having a peripheral venous line (PVL) or with the patient needing PVL cannulation at some point during the simulation. Therefore, we can select this button before starting the scenario or during it.",
    IT: "Lo scenario può iniziare con il paziente che ha già una linea venosa periferica (LVP) o con il paziente che necessita di cannulazione LVP ad un certo punto durante la simulazione. Pertanto, possiamo selezionare questo pulsante prima di iniziare lo scenario o durante esso.",
    PT: "O cenário pode começar com o doente já portador de via venosa periférica (VVP) ou com o doente precisando de canalização de VVP em algum momento da simulação. Por conseguinte, poderemos selecionar este botão antes de começar o cenário ou durante o mesmo.",
  },
  {
    id: "iot_dsg_button",
    ES: "IOT/DSG",
    EN: "ETT/SGA",
    IT: "IOT/DSG",
    PT: "IOT/DSG",
  },
  {
    id: "iot_dsg_description",
    ES: "El caso clínico puede comenzar con el paciente siendo ya portador de tubo orotraqueal/dispositivo supraglótico (IOT/DSG) o con el paciente precisando IOT/DSG en algún momento de la simulación. Por tanto, podremos seleccionar este botón antes de comenzar el escenario o durante el mismo.",
    EN: "The clinical case can begin with the patient already having an endotracheal tube/supraglottic device (ETT/SGA) or with the patient needing ETT/SGA at some point during the simulation. Therefore, we can select this button before starting the scenario or during it.",
    IT: "Il caso clinico può iniziare con il paziente che ha già un tubo endotracheale/dispositivo sopraglottico (IOT/DSG) o con il paziente che necessita di IOT/DSG ad un certo punto durante la simulazione. Pertanto, possiamo selezionare questo pulsante prima di iniziare lo scenario o durante esso.",
    PT: "O caso clínico pode começar com o doente já portador de tubo orotraqueal/dispositivo supraglótico (IOT/DSG) ou com o doente precisando de IOT/DSG em algum momento da simulação. Por conseguinte, poderemos selecionar este botão antes de começar o cenário ou durante o mesmo.",
  },
  {
    id: "vascular_access_active",
    ES: "establecido",
    EN: "established",
    IT: "stabilito",
    PT: "estabelecido",
  },
  {
    id: "vascular_access_inactive",
    ES: "no establecido",
    EN: "not established",
    IT: "non stabilito",
    PT: "não estabelecido",
  },
  {
    id: "Borrar todos los datos",
    ES: "Borrar todos los datos",
    EN: "Clear all data",
    IT: "Cancella tutti i dati",
    PT: "Apagar todos os dados",
  },
  {
    id: "¿Borrar todos los datos?",
    ES: "¿Borrar todos los datos?",
    EN: "Clear all data?",
    IT: "Cancellare tutti i dati?",
    PT: "Apagar todos os dados?",
  },
  {
    id: "Esta acción borrará todos los informes guardados, configuraciones y datos almacenados en el navegador. No se puede deshacer.",
    ES: "Esta acción borrará todos los informes guardados, configuraciones y datos almacenados en el navegador. No se puede deshacer.",
    EN: "This action will delete all saved reports, settings and data stored in the browser. This cannot be undone.",
    IT: "Questa azione eliminerà tutti i rapporti salvati, le impostazioni e i dati memorizzati nel browser. Non può essere annullata.",
    PT: "Esta ação irá eliminar todos os relatórios guardados, configurações e dados armazenados no navegador. Não pode ser desfeita.",
  },
  {
    id: "Limpiando datos...",
    ES: "Limpiando datos...",
    EN: "Clearing data...",
    IT: "Cancellando dati...",
    PT: "Apagando dados...",
  },
  {
    id: "Por favor espera mientras se limpian todos los datos de la aplicación.",
    ES: "Por favor espera mientras se limpian todos los datos de la aplicación.",
    EN: "Please wait while all application data is being cleared.",
    IT: "Attendere mentre tutti i dati dell'applicazione vengono cancellati.",
    PT: "Por favor aguarde enquanto todos os dados da aplicação estão a ser apagados.",
  },
  {
    id: "Tiempo medio de administración",
    ES: "Tiempo medio de administración",
    EN: "Average administration time",
    IT: "Tempo medio di somministrazione",
    PT: "Tempo médio de administração",
  },
];
